import React, { useState, useEffect, Fragment, useRef } from 'react';
import * as d3 from 'd3';
import logoMonthlyReport from '../../../assets/images/logo_monthly_report.svg';
import monthlyReportBg from '../../../assets/images/monthly_report_bg.png';
import {getRecoil} from "recoil-nexus";
import {schoolNameState} from "../../../recoil/teacher/teacherIdState";
import {useRecoilValue} from "recoil";
import {mainClassState} from "../../../recoil/classes/classesState";
import report5Smile from "../../../assets/images/monthly_report_5_smile.png"
import report5Sad from "../../../assets/images/monthly_report_5_sad.png"
import iconSmile from "../../../assets/images/icon-smile.svg"
import iconSmile2 from "../../../assets/images/icon-smile2.svg"
import iconSmile3 from "../../../assets/images/icon-smile3.svg"
import grade1 from "../../../assets/images/grade_1.svg";
import grade2 from "../../../assets/images/grade_2.svg";
import grade3 from "../../../assets/images/grade_3.svg";
import grade4 from "../../../assets/images/grade_4.svg";
import grade5 from "../../../assets/images/grade_5.svg";
import schoolIco from "../../../assets/images/School_ico.png";
import studyIco from "../../../assets/images/study_ico.png";
import modeLesson from "../../../assets/images/mode_lesson.png";
import modeHomeWork from "../../../assets/images/mode_homework.png";
import modeDaily from "../../../assets/images/mode_daily.png";
import modeFree from "../../../assets/images/mode_free.png";
import modeChallenge from "../../../assets/images/mode_challeng.png";



const StudentMonthlyReport = ({ monthlyData, selectedMonth, studentInfo }) => {
  const recoilSchoolName = useRecoilValue(schoolNameState);
  const recoilMainClass = useRecoilValue(mainClassState);
  
  // API 응답에 학교 정보가 있으면 우선 사용, 없으면 recoil에서 가져옴
  const schoolName = monthlyData?.schoolName || recoilSchoolName;
  const mainClass = monthlyData?.className ? { name: monthlyData.className } : recoilMainClass;
  
  // API 응답에 학생 이름이 있으면 우선 사용, 없으면 props에서 가져옴
  const studentName = monthlyData?.studentName || studentInfo?.name || '학생';

  // D3 차트를 위한 ref
  const learningCountChartRef = useRef(null);
  const accuracyChartRef = useRef(null);
  const learningTimeChartRef = useRef(null);
  const weeklyLearningCountChartRef = useRef(null);
  const weeklyAccuracyChartRef = useRef(null);
  const weeklyLearningTimeChartRef = useRef(null);


  // 상태 관리
  const [calendarData, setCalendarData] = useState([]);
  const [attendanceCount, setAttendanceCount] = useState(0);
  const [learningCount, setLearningCount] = useState(0);
  const [averageLearningCount, setAverageLearningCount] = useState(0);
  const [averageLearningTimeSeconds, setAverageLearningTimeSeconds] = useState(0);
  const [averageAccuracy, setAverageAccuracy] = useState(0);
  const [learningTimeSeconds, setLearningTimeSeconds] = useState(0);
  const [problemCount, setProblemCount] = useState(0);

  // 학습 모드별 비율
  const [lessonModePercent, setLessonModePercent] = useState(0);
  const [homeworkModePercent, setHomeworkModePercent] = useState(0);
  const [dailyModePercent, setDailyModePercent] = useState(0);
  const [freeModePercent, setFreeModePercent] = useState(0);
  const [challengeModePercent, setChallengeModePercent] = useState(0);

  const learningModeEn = ["lesson", "homework", "daily", "free", "challenge"];
  const learningModeKo = ["수업 학습", "숙제", "오늘의 학습", "자유 학습", "챌린지"];
  const [topLearningMode, setTopLearningMode] = useState(0);

  // 월별/주별 비교 데이터
  const [monthlyLearningData2, setMonthlyLearningData2] = useState([]);
  const [weeklyLearningData2, setWeeklyLearningData2] = useState([]);
  const [maxLearningCount, setMaxLearningCount] = useState(3);
  const [maxAccuracy, setMaxAccuracy] = useState(1);
  const [maxLearningTimeMinutes, setMaxLearningTimeMinutes] = useState(5);
  const [weeklyMaxLearningCount, setWeeklyMaxLearningCount] = useState(3);
  const [weeklyMaxAccuracy, setWeeklyMaxAccuracy] = useState(1);
  const [weeklyMaxLearningTimeMinutes, setWeeklyMaxLearningTimeMinutes] = useState(5);

  // 전월 비교 데이터
  const [preMonthComparisonLearningCount, setPreMonthComparisonLearningCount] = useState(0);
  const [preMonthComparisonAccuracy, setPreMonthComparisonAccuracy] = useState(0.0);
  const [preMonthComparisonLearningTimeSeconds, setPreMonthComparisonLearningTimeSeconds] = useState(0);
  const [preMonthComparisonProblemCount, setPreMonthComparisonProblemCount] = useState(0);
  const [hasPreviousMonthData, setHasPreviousMonthData] = useState(false);

  // 레벨/단원 데이터
  const [levelData, setLevelData] = useState([]);
  const [levelData2, setLevelData2] = useState([]);
  const [maxLevel, setMaxLevel] = useState(0);
  const [levelAndChapterData2, setLevelAndChapterData2] = useState([]);
  const [levelAndChapterMaxLevel, setLevelAndChapterMaxLevel] = useState(0);
  const [levelAndChapterMaxChapter, setLevelAndChapterMaxChapter] = useState(0);
  const [levelAndChapterMaxChapterName, setLevelAndChapterMaxChapterName] = useState("");

  // 우수/취약 스테이지
  const [excellentLearningData, setExcellentLearningData] = useState([]);
  const [weekLearningData, setWeekLearningData] = useState([]);

  // 상세 학습 결과
  const [recordsData, setRecordsData] = useState([]);
  const [learningData2, setLearningData2] = useState([]);
  const [learningData3, setLearningData3] = useState([]);
  const [numberOfLearningData, setNumberOfLearningData] = useState(0);

  // 트로피 개수
  const [onePercentTrophy, setOnePercentTrophy] = useState(0);
  const [tenPercentTrophy, setTenPercentTrophy] = useState(0);
  const [thirtyPercentTrophy, setThirtyPercentTrophy] = useState(0);
  const [fiftyPercentTrophy, setFiftyPercentTrophy] = useState(0);
  const [goodTrophy, setGoodTrophy] = useState(0);

  // 헬퍼 함수들
  const mm = (seconds) => {
    let min = parseInt(seconds / 60);
    return min;
  };

  const ss = (seconds) => {
    let second = parseInt(seconds % 60);
    return second > 0 ? second : "";
  };

  const mm2 = (seconds) => {
    let min = parseInt(seconds / 60);
    return min > 0 ? min + "분" : "";
  };

  const ss2 = (seconds) => {
    let second = parseInt(seconds % 60);
    return second + "초";
  };

  const checkLine = text => {
    return (
      <Fragment>
        {text.split("\n").map((txt, index) => (
          <Fragment key={index}>
            {txt}
            <br />
          </Fragment>
        ))}
      </Fragment>
    );
  };

  // 데이터 처리 함수들
  const processCalendarData = () => {
    if (!monthlyData?.dailyLearningCounts) return;

    const year = selectedMonth.year;
    const month = selectedMonth.month;
    const daysInMonth = new Date(year, month, 0).getDate();
    const firstDay = new Date(year, month - 1, 1).getDay();

    let weeks = [];
    let currentWeek = [];

    // 첫 주의 빈 칸들 채우기
    for (let i = 0; i < firstDay; i++) {
      currentWeek.push({
        day: "",
        learningCount: 0,
        attendanceStatus: false,
        sequence: i + 1,
        learningDate: ""
      });
    }

    // 실제 날짜들 채우기
    for (let day = 1; day <= daysInMonth; day++) {
      const learningCount = monthlyData.dailyLearningCounts[day] || 0;
      const learningDate = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;

      currentWeek.push({
        day: day,
        learningCount: learningCount,
        attendanceStatus: learningCount > 0,
        sequence: currentWeek.length + 1,
        learningDate: learningDate
      });

      if (currentWeek.length === 7) {
        weeks.push(currentWeek);
        currentWeek = [];
      }
    }

    // 마지막 주 채우기
    while (currentWeek.length < 7) {
      currentWeek.push({
        day: "",
        learningCount: 0,
        attendanceStatus: false,
        sequence: currentWeek.length + 1,
        learningDate: ""
      });
    }
    if (currentWeek.length > 0) {
      weeks.push(currentWeek);
    }

    setCalendarData(weeks);

    // 출석 일수 및 학습 통계 계산
    let attendanceCount = 0;
    let totalLearningCount = 0;

    Object.values(monthlyData.dailyLearningCounts).forEach(count => {
      if (count > 0) {
        attendanceCount++;
        totalLearningCount += count;
      }
    });

    setAttendanceCount(attendanceCount);
    setLearningCount(totalLearningCount);
    setAverageLearningCount(attendanceCount > 0 ? Math.ceil((totalLearningCount / attendanceCount) * 10) / 10 : 0);
  };

  const processMonthlyData = () => {
    if (!monthlyData) return;

    const currentMonthKey = `${selectedMonth.year}-${String(selectedMonth.month).padStart(2, '0')}`;

    // 현재 월 데이터
    const currentStudyTime = monthlyData.monthlyTotalStudyTime[currentMonthKey] || 0;
    const currentAccuracy = monthlyData.monthlyAverageAccuracy[currentMonthKey] || 0;
    const currentStageCount = monthlyData.monthlyStageCnt[currentMonthKey] || 0;
    const currentProblemCount = monthlyData.monthlySolveCnt[currentMonthKey] || 0;

    setLearningTimeSeconds(currentStudyTime);
    setAverageAccuracy(Math.round(currentAccuracy * 10) / 10);
    setProblemCount(currentProblemCount);
    setAverageLearningTimeSeconds(attendanceCount > 0 ? Math.round(currentStudyTime / attendanceCount) : 0);

    // 월별 비교 데이터 생성
    const monthlyData2 = [];
    Object.entries(monthlyData.monthlyTotalStudyTime).forEach(([key, value]) => {
      const [year, month] = key.split('-');
      monthlyData2.push({
        date: key,
        learningCount: monthlyData.monthlyStageCnt[key] || 0,
        accuracy: monthlyData.monthlyAverageAccuracy[key] || 0,
        learningTimeMinutes: Math.round((monthlyData.monthlyTotalStudyTime[key] || 0) / 60),
        learningTimeSeconds: monthlyData.monthlyTotalStudyTime[key] || 0,
        problemCount: monthlyData.monthlySolveCnt[key] || 0
      });
    });

    setMonthlyLearningData2(monthlyData2);

    // 최대값 계산
    const maxLearning = Math.max(...monthlyData2.map(d => d.learningCount));
    const maxTime = Math.max(...monthlyData2.map(d => d.learningTimeMinutes));
    const maxAcc = Math.max(...monthlyData2.map(d => d.accuracy));

    setMaxLearningCount(maxLearning > 3 ? maxLearning : 3);
    setMaxLearningTimeMinutes(maxTime > 5 ? maxTime : 5);
    setMaxAccuracy(maxAcc > 1 ? maxAcc : 1);

    // 전월 비교 데이터 계산
    const sortedData = monthlyData2.sort((a, b) => a.date.localeCompare(b.date));
    const currentIndex = sortedData.findIndex(d => d.date === currentMonthKey);

    if (currentIndex > 0) {
      const prevData = sortedData[currentIndex - 1];
      const currentData = sortedData[currentIndex];

      // 전월 데이터가 실제로 존재하는지 확인 (0이 아닌 값이 하나라도 있는지)
      const hasPrevData = prevData.learningCount > 0 ||
                         prevData.accuracy > 0 ||
                         prevData.learningTimeSeconds > 0 ||
                         prevData.problemCount > 0;

      if (hasPrevData) {
        setPreMonthComparisonLearningCount(currentData.learningCount - prevData.learningCount);
        setPreMonthComparisonAccuracy(Math.ceil((currentData.accuracy - prevData.accuracy) * 10) / 10);
        setPreMonthComparisonLearningTimeSeconds(currentData.learningTimeSeconds - prevData.learningTimeSeconds);
        setPreMonthComparisonProblemCount(currentData.problemCount - prevData.problemCount);
        setHasPreviousMonthData(true);
      } else {
        // 전월 데이터가 없는 경우 초기화
        setPreMonthComparisonLearningCount(0);
        setPreMonthComparisonAccuracy(0);
        setPreMonthComparisonLearningTimeSeconds(0);
        setPreMonthComparisonProblemCount(0);
        setHasPreviousMonthData(false);
      }
    } else {
      // 이전 월이 없는 경우
      setPreMonthComparisonLearningCount(0);
      setPreMonthComparisonAccuracy(0);
      setPreMonthComparisonLearningTimeSeconds(0);
      setPreMonthComparisonProblemCount(0);
      setHasPreviousMonthData(false);
    }
  };

  const processWeeklyData = () => {
    if (!monthlyData?.weeklyTotalStudyTime) return;

    const weeklyData2 = [];
    Object.entries(monthlyData.weeklyTotalStudyTime).forEach(([key, value]) => {
      weeklyData2.push({
        date: key, // 전체 키값 사용 (예: "02-24~03-02")
        learningCount: monthlyData.weeklyStageCnt[key] || 0,
        accuracy: monthlyData.weeklyAverageAccuracy[key] || 0,
        learningTimeMinutes: Math.round((value || 0) / 60),
        learningTimeSeconds: value || 0
      });
    });

    setWeeklyLearningData2(weeklyData2);

    // 주별 최대값 계산
    const weeklyMaxLearning = Math.max(...weeklyData2.map(d => d.learningCount));
    const weeklyMaxTime = Math.max(...weeklyData2.map(d => d.learningTimeMinutes));
    const weeklyMaxAcc = Math.max(...weeklyData2.map(d => d.accuracy));

    setWeeklyMaxLearningCount(weeklyMaxLearning > 3 ? weeklyMaxLearning : 3);
    setWeeklyMaxLearningTimeMinutes(weeklyMaxTime > 5 ? weeklyMaxTime : 5);
    setWeeklyMaxAccuracy(weeklyMaxAcc > 1 ? weeklyMaxAcc : 1);
  };

  const processLearningModeData = () => {
    if (!monthlyData?.ratingByMode) return;

    const total = Object.values(monthlyData.ratingByMode).reduce((sum, count) => sum + count, 0);

    if (total === 0) {
      setLessonModePercent(0);
      setHomeworkModePercent(0);
      setDailyModePercent(0);
      setFreeModePercent(0);
      setChallengeModePercent(0);
      setTopLearningMode(0);
      return;
    }

    const lessonPercent = Math.round((monthlyData.ratingByMode.LESSON / total) * 100);
    const homeworkPercent = Math.round((monthlyData.ratingByMode.HOMEWORK / total) * 100);
    const dailyPercent = Math.round((monthlyData.ratingByMode.DAILY / total) * 100);
    const freePercent = Math.round((monthlyData.ratingByMode.FREE / total) * 100);
    const challengePercent = Math.round((monthlyData.ratingByMode.CHALLENGE / total) * 100);

    setLessonModePercent(lessonPercent);
    setHomeworkModePercent(homeworkPercent);
    setDailyModePercent(dailyPercent);
    setFreeModePercent(freePercent);
    setChallengeModePercent(challengePercent);

    // 가장 많이 한 학습 모드 찾기
    const modeValues = [
      monthlyData.ratingByMode.LESSON,
      monthlyData.ratingByMode.HOMEWORK,
      monthlyData.ratingByMode.DAILY,
      monthlyData.ratingByMode.FREE,
      monthlyData.ratingByMode.CHALLENGE
    ];

    const maxModeIndex = modeValues.findIndex(value => value === Math.max(...modeValues));
    setTopLearningMode(maxModeIndex + 1);
  };

  // 데이터 초기화
  useEffect(() => {
    if (monthlyData && studentInfo) {
      console.log(studentInfo);
      processCalendarData();
      processMonthlyData();
      processWeeklyData();
      processLearningModeData();
      processRecordsData();
    }
  }, [monthlyData, selectedMonth, attendanceCount, studentInfo]);

  // D3 차트 렌더링용 useEffect
  useEffect(() => {
    if (monthlyLearningData2.length > 0) {
      if (learningCountChartRef.current) createLearningCountChart();
      if (accuracyChartRef.current) createAccuracyChart();
      if (learningTimeChartRef.current) createLearningTimeChart();
    }
  }, [monthlyLearningData2]);

  useEffect(() => {
    if (weeklyLearningData2.length > 0) {
      if (weeklyLearningCountChartRef.current) createWeeklyLearningCountChart();
      if (weeklyAccuracyChartRef.current) createWeeklyAccuracyChart();
      if (weeklyLearningTimeChartRef.current) createWeeklyLearningTimeChart();
    }
  }, [weeklyLearningData2]);

  // D3 학습량 차트 생성 함수
  const createLearningCountChart = () => {
    if (!learningCountChartRef.current) return;

    // 기존 SVG 삭제
    d3.select(learningCountChartRef.current).selectAll("*").remove();

    // 데이터 준비
    const data = monthlyLearningData2.map((item, index) => ({
      month: new Date(item.date).getMonth() + 1 + '월',
      count: item.learningCount,
      isLastMonth: index === monthlyLearningData2.length - 1
    }));

    // SVG 크기 설정
    const margin = { top: 40, right: 30, bottom: 50, left: 50 };
    const width = 900 - margin.left - margin.right;
    const height = 280 - margin.top - margin.bottom;

    // SVG 생성
    const svg = d3.select(learningCountChartRef.current)
      .append("svg")
      .attr("width", 900)
      .attr("height", 280)
      .append("g")
      .attr("transform", `translate(${margin.left},${margin.top})`);

    // X축 스케일 설정
    const x = d3.scaleBand()
      .domain(d3.range(data.length))
      .range([0, width])
      .padding(0.5);

    // 막대 너비 - 고정 24px
    const barWidth = 24;
    const barOffset = (x.bandwidth() - barWidth) / 2;

    // Y축 스케일 설정
    const maxValue = d3.max(data, d => d.count) || 10;
    const yMax = Math.ceil(maxValue / 10) * 10;
    const y = d3.scaleLinear()
      .domain([0, yMax])
      .range([height, 0]);

    // 수평 그리드 라인 그리기
    svg.selectAll("line.horizontalGrid")
      .data(y.ticks(5))
      .enter()
      .append("line")
      .attr("class", "horizontalGrid")
      .attr("x1", 0)
      .attr("x2", width)
      .attr("y1", d => y(d))
      .attr("y2", d => y(d))
      .attr("stroke", "#E8E8E8")
      .attr("stroke-width", 1);

    // Y축 눈금과 레이블 설정
    svg.selectAll(".y-label")
      .data(y.ticks(5))
      .enter()
      .append("text")
      .attr("class", "y-label")
      .attr("x", -10)
      .attr("y", d => y(d))
      .attr("dy", "0.32em")
      .attr("text-anchor", "end")
      .attr("fill", "#50555F")
      .style("font-size", "16px")
      .style("font-weight", "500")
      .text(d => d + "개");

    // X축 그리기 (바닥 선만)
    svg.append("line")
      .attr("x1", 0)
      .attr("x2", width)
      .attr("y1", height)
      .attr("y2", height)
      .attr("stroke", "#E8E8E8")
      .attr("stroke-width", 1);

    // X축 레이블
    svg.selectAll(".x-label")
      .data(data)
      .enter()
      .append("text")
      .attr("class", "x-label")
      .attr("x", (d, i) => x(i) + x.bandwidth() / 2)
      .attr("y", height + 30)
      .attr("text-anchor", "middle")
      .attr("fill", "#50555F")
      .style("font-size", "16px")
      .style("font-weight", "500")
      .text(d => d.month);

    // 막대 그리기
    svg.selectAll(".bar")
      .data(data)
      .enter()
      .append("path")
      .attr("class", "bar")
      .attr("d", (d, i) => {
        if (d.count === 0) return "";

        const x0 = x(i) + barOffset;
        const y0 = y(d.count);
        const cornerRadius = 12;

        return `
          M ${x0},${height}
          L ${x0},${y0 + cornerRadius}
          Q ${x0},${y0} ${x0 + cornerRadius},${y0}
          L ${x0 + barWidth - cornerRadius},${y0}
          Q ${x0 + barWidth},${y0} ${x0 + barWidth},${y0 + cornerRadius}
          L ${x0 + barWidth},${height}
          Z
        `;
      })
      .attr("fill", d => d.isLastMonth ? "#7494FF" : "#DBE3FF");

    // 값 표시
    svg.selectAll(".bar-value")
      .data(data)
      .enter()
      .append("text")
      .attr("class", "bar-value")
      .attr("x", (d, i) => x(i) + barOffset + barWidth / 2)
      .attr("y", d => y(d.count) - 10)
      .attr("text-anchor", "middle")
      .attr("fill", d => d.isLastMonth ? "#355BDF" : "#50555F")
      .style("font-size", "16px")
      .style("font-weight", "500")
             .text(d => d.count);
  };

  // D3 정확도 차트 생성 함수
  const createAccuracyChart = () => {
    if (!accuracyChartRef.current) return;

    d3.select(accuracyChartRef.current).selectAll("*").remove();

    const data = monthlyLearningData2.map((item, index) => ({
      month: new Date(item.date).getMonth() + 1 + '월',
      accuracy: item.accuracy,
      isLastMonth: index === monthlyLearningData2.length - 1
    }));

    const margin = { top: 40, right: 30, bottom: 50, left: 50 };
    const width = 900 - margin.left - margin.right;
    const height = 280 - margin.top - margin.bottom;

    const svg = d3.select(accuracyChartRef.current)
      .append("svg")
      .attr("width", 900)
      .attr("height", 280)
      .append("g")
      .attr("transform", `translate(${margin.left},${margin.top})`);

    const x = d3.scaleBand()
      .domain(d3.range(data.length))
      .range([0, width])
      .padding(0.5);

    const barWidth = 24;
    const barOffset = (x.bandwidth() - barWidth) / 2;

    const y = d3.scaleLinear()
      .domain([0, 100])
      .range([height, 0]);

    svg.selectAll("line.horizontalGrid")
      .data([0, 20, 40, 60, 80, 100])
      .enter()
      .append("line")
      .attr("class", "horizontalGrid")
      .attr("x1", 0)
      .attr("x2", width)
      .attr("y1", d => y(d))
      .attr("y2", d => y(d))
      .attr("stroke", "#E8E8E8")
      .attr("stroke-width", 1);

    svg.selectAll(".y-label")
      .data([0, 20, 40, 60, 80, 100])
      .enter()
      .append("text")
      .attr("class", "y-label")
      .attr("x", -10)
      .attr("y", d => y(d))
      .attr("dy", "0.32em")
      .attr("text-anchor", "end")
      .attr("fill", "#50555F")
      .style("font-size", "16px")
      .style("font-weight", "500")
      .text(d => d + "%");

    svg.append("line")
      .attr("x1", 0)
      .attr("x2", width)
      .attr("y1", height)
      .attr("y2", height)
      .attr("stroke", "#E8E8E8")
      .attr("stroke-width", 1);

    svg.selectAll(".x-label")
      .data(data)
      .enter()
      .append("text")
      .attr("class", "x-label")
      .attr("x", (d, i) => x(i) + x.bandwidth() / 2)
      .attr("y", height + 30)
      .attr("text-anchor", "middle")
      .attr("fill", "#50555F")
      .style("font-size", "16px")
      .style("font-weight", "500")
      .text(d => d.month);

    svg.selectAll(".bar")
      .data(data)
      .enter()
      .append("path")
      .attr("class", "bar")
      .attr("d", (d, i) => {
        if (d.accuracy === 0) return "";

        const x0 = x(i) + barOffset;
        const y0 = y(d.accuracy);
        const cornerRadius = 12;

        return `
          M ${x0},${height}
          L ${x0},${y0 + cornerRadius}
          Q ${x0},${y0} ${x0 + cornerRadius},${y0}
          L ${x0 + barWidth - cornerRadius},${y0}
          Q ${x0 + barWidth},${y0} ${x0 + barWidth},${y0 + cornerRadius}
          L ${x0 + barWidth},${height}
          Z
        `;
      })
      .attr("fill", d => d.isLastMonth ? "#74CEB2" : "#DBEFED");

    svg.selectAll(".bar-value")
      .data(data)
      .enter()
      .append("text")
      .attr("class", "bar-value")
      .attr("x", (d, i) => x(i) + barOffset + barWidth / 2)
      .attr("y", d => y(d.accuracy) - 10)
      .attr("text-anchor", "middle")
      .attr("fill", d => d.isLastMonth ? "#008979" : "#50555F")
      .style("font-size", "16px")
      .style("font-weight", "500")
      .text(d => d.accuracy.toFixed(1));
  };

  // D3 학습시간 차트 생성 함수
  const createLearningTimeChart = () => {
    if (!learningTimeChartRef.current) return;

    d3.select(learningTimeChartRef.current).selectAll("*").remove();

    const data = monthlyLearningData2.map((item, index) => ({
      month: new Date(item.date).getMonth() + 1 + '월',
      time: item.learningTimeMinutes,
      isLastMonth: index === monthlyLearningData2.length - 1
    }));

    const margin = { top: 40, right: 30, bottom: 50, left: 50 };
    const width = 900 - margin.left - margin.right;
    const height = 280 - margin.top - margin.bottom;

    const svg = d3.select(learningTimeChartRef.current)
      .append("svg")
      .attr("width", 900)
      .attr("height", 280)
      .append("g")
      .attr("transform", `translate(${margin.left},${margin.top})`);

    const x = d3.scaleBand()
      .domain(d3.range(data.length))
      .range([0, width])
      .padding(0.5);

    const barWidth = 24;
    const barOffset = (x.bandwidth() - barWidth) / 2;

    const maxTime = d3.max(data, d => d.time) || 5;
    const yMax = maxTime <= 6 ? maxTime : Math.ceil(maxTime / 5) * 5;
    const y = d3.scaleLinear()
      .domain([0, yMax])
      .range([height, 0]);

    const yTicks = maxTime <= 6 ? d3.range(0, yMax + 1) : y.ticks(6);

    svg.selectAll("line.horizontalGrid")
      .data(yTicks)
      .enter()
      .append("line")
      .attr("class", "horizontalGrid")
      .attr("x1", 0)
      .attr("x2", width)
      .attr("y1", d => y(d))
      .attr("y2", d => y(d))
      .attr("stroke", "#E8E8E8")
      .attr("stroke-width", 1);

    svg.selectAll(".y-label")
      .data(yTicks)
      .enter()
      .append("text")
      .attr("class", "y-label")
      .attr("x", -10)
      .attr("y", d => y(d))
      .attr("dy", "0.32em")
      .attr("text-anchor", "end")
      .attr("fill", "#50555F")
      .style("font-size", "16px")
      .style("font-weight", "500")
      .text(d => d + "분");

    svg.append("line")
      .attr("x1", 0)
      .attr("x2", width)
      .attr("y1", height)
      .attr("y2", height)
      .attr("stroke", "#E8E8E8")
      .attr("stroke-width", 1);

    svg.selectAll(".x-label")
      .data(data)
      .enter()
      .append("text")
      .attr("class", "x-label")
      .attr("x", (d, i) => x(i) + x.bandwidth() / 2)
      .attr("y", height + 30)
      .attr("text-anchor", "middle")
      .attr("fill", "#50555F")
      .style("font-size", "16px")
      .style("font-weight", "500")
      .text(d => d.month);

    svg.selectAll(".bar")
      .data(data)
      .enter()
      .append("path")
      .attr("class", "bar")
      .attr("d", (d, i) => {
        if (d.time === 0) return "";

        const x0 = x(i) + barOffset;
        const y0 = y(d.time);
        const cornerRadius = 12;

        return `
          M ${x0},${height}
          L ${x0},${y0 + cornerRadius}
          Q ${x0},${y0} ${x0 + cornerRadius},${y0}
          L ${x0 + barWidth - cornerRadius},${y0}
          Q ${x0 + barWidth},${y0} ${x0 + barWidth},${y0 + cornerRadius}
          L ${x0 + barWidth},${height}
          Z
        `;
      })
      .attr("fill", d => d.isLastMonth ? "#FFD67D" : "#FFEFCA");

    svg.selectAll(".bar-value")
      .data(data)
      .enter()
      .append("text")
      .attr("class", "bar-value")
      .attr("x", (d, i) => x(i) + barOffset + barWidth / 2)
      .attr("y", d => y(d.time) - 10)
      .attr("text-anchor", "middle")
      .attr("fill", d => d.isLastMonth ? "#FF8C00" : "#50555F")
      .style("font-size", "16px")
      .style("font-weight", "500")
      .text(d => d.time);
  };

  // 주별 차트 함수들
  const createWeeklyLearningCountChart = () => {
    if (!weeklyLearningCountChartRef.current) return;

    d3.select(weeklyLearningCountChartRef.current).selectAll("*").remove();

    const data = weeklyLearningData2.map(item => ({
      week: item.date,
      count: item.learningCount
    }));

    const margin = { top: 40, right: 30, bottom: 50, left: 50 };
    const width = 900 - margin.left - margin.right;
    const height = 280 - margin.top - margin.bottom;

    const svg = d3.select(weeklyLearningCountChartRef.current)
      .append("svg")
      .attr("width", 900)
      .attr("height", 280)
      .append("g")
      .attr("transform", `translate(${margin.left},${margin.top})`);

    const x = d3.scaleBand()
      .domain(d3.range(data.length))
      .range([0, width])
      .padding(0.5);

    const barWidth = 24;
    const barOffset = (x.bandwidth() - barWidth) / 2;

    const maxValue = d3.max(data, d => d.count) || 10;
    const yMax = Math.ceil(maxValue / 10) * 10;
    const y = d3.scaleLinear()
      .domain([0, yMax])
      .range([height, 0]);

    svg.selectAll("line.horizontalGrid")
      .data(y.ticks(5))
      .enter()
      .append("line")
      .attr("class", "horizontalGrid")
      .attr("x1", 0)
      .attr("x2", width)
      .attr("y1", d => y(d))
      .attr("y2", d => y(d))
      .attr("stroke", "#E8E8E8")
      .attr("stroke-width", 1);

    svg.selectAll(".y-label")
      .data(y.ticks(5))
      .enter()
      .append("text")
      .attr("class", "y-label")
      .attr("x", -10)
      .attr("y", d => y(d))
      .attr("dy", "0.32em")
      .attr("text-anchor", "end")
      .attr("fill", "#50555F")
      .style("font-size", "16px")
      .style("font-weight", "500")
      .text(d => d + "개");

    svg.append("line")
      .attr("x1", 0)
      .attr("x2", width)
      .attr("y1", height)
      .attr("y2", height)
      .attr("stroke", "#E8E8E8")
      .attr("stroke-width", 1);

    svg.selectAll(".x-label")
      .data(data)
      .enter()
      .append("text")
      .attr("class", "x-label")
      .attr("x", (d, i) => x(i) + x.bandwidth() / 2)
      .attr("y", height + 30)
      .attr("text-anchor", "middle")
      .attr("fill", "#50555F")
      .style("font-size", "16px")
      .style("font-weight", "500")
      .text(d => d.week);

    svg.selectAll(".bar")
      .data(data)
      .enter()
      .append("path")
      .attr("class", "bar")
      .attr("d", (d, i) => {
        if (d.count === 0) return "";

        const x0 = x(i) + barOffset;
        const y0 = y(d.count);
        const cornerRadius = 12;

        return `
          M ${x0},${height}
          L ${x0},${y0 + cornerRadius}
          Q ${x0},${y0} ${x0 + cornerRadius},${y0}
          L ${x0 + barWidth - cornerRadius},${y0}
          Q ${x0 + barWidth},${y0} ${x0 + barWidth},${y0 + cornerRadius}
          L ${x0 + barWidth},${height}
          Z
        `;
      })
      .attr("fill", "#7494FF");

    svg.selectAll(".bar-value")
      .data(data)
      .enter()
      .append("text")
      .attr("class", "bar-value")
      .attr("x", (d, i) => x(i) + barOffset + barWidth / 2)
      .attr("y", d => y(d.count) - 10)
      .attr("text-anchor", "middle")
      .attr("fill", "#50555F")
      .style("font-size", "14px")
      .style("font-weight", "500")
      .text(d => d.count);
  };

  const createWeeklyAccuracyChart = () => {
    if (!weeklyAccuracyChartRef.current) return;

    d3.select(weeklyAccuracyChartRef.current).selectAll("*").remove();

    const data = weeklyLearningData2.map(item => ({
      week: item.date,
      accuracy: item.accuracy
    }));

    const margin = { top: 40, right: 30, bottom: 50, left: 50 };
    const width = 900 - margin.left - margin.right;
    const height = 280 - margin.top - margin.bottom;

    const svg = d3.select(weeklyAccuracyChartRef.current)
      .append("svg")
      .attr("width", 900)
      .attr("height", 280)
      .append("g")
      .attr("transform", `translate(${margin.left},${margin.top})`);

    const x = d3.scaleBand()
      .domain(d3.range(data.length))
      .range([0, width])
      .padding(0.5);

    const barWidth = 24;
    const barOffset = (x.bandwidth() - barWidth) / 2;

    const y = d3.scaleLinear()
      .domain([0, 100])
      .range([height, 0]);

    svg.selectAll("line.horizontalGrid")
      .data([0, 20, 40, 60, 80, 100])
      .enter()
      .append("line")
      .attr("class", "horizontalGrid")
      .attr("x1", 0)
      .attr("x2", width)
      .attr("y1", d => y(d))
      .attr("y2", d => y(d))
      .attr("stroke", "#E8E8E8")
      .attr("stroke-width", 1);

    svg.selectAll(".y-label")
      .data([0, 20, 40, 60, 80, 100])
      .enter()
      .append("text")
      .attr("class", "y-label")
      .attr("x", -10)
      .attr("y", d => y(d))
      .attr("dy", "0.32em")
      .attr("text-anchor", "end")
      .attr("fill", "#50555F")
      .style("font-size", "16px")
      .style("font-weight", "500")
      .text(d => d + "%");

    svg.append("line")
      .attr("x1", 0)
      .attr("x2", width)
      .attr("y1", height)
      .attr("y2", height)
      .attr("stroke", "#E8E8E8")
      .attr("stroke-width", 1);

    svg.selectAll(".x-label")
      .data(data)
      .enter()
      .append("text")
      .attr("class", "x-label")
      .attr("x", (d, i) => x(i) + x.bandwidth() / 2)
      .attr("y", height + 30)
      .attr("text-anchor", "middle")
      .attr("fill", "#50555F")
      .style("font-size", "16px")
      .style("font-weight", "500")
      .text(d => d.week);

    svg.selectAll(".bar")
      .data(data)
      .enter()
      .append("path")
      .attr("class", "bar")
      .attr("d", (d, i) => {
        if (d.accuracy === 0) return "";

        const x0 = x(i) + barOffset;
        const y0 = y(d.accuracy);
        const cornerRadius = 12;

        return `
          M ${x0},${height}
          L ${x0},${y0 + cornerRadius}
          Q ${x0},${y0} ${x0 + cornerRadius},${y0}
          L ${x0 + barWidth - cornerRadius},${y0}
          Q ${x0 + barWidth},${y0} ${x0 + barWidth},${y0 + cornerRadius}
          L ${x0 + barWidth},${height}
          Z
        `;
      })
      .attr("fill", "#74CEB2");

    svg.selectAll(".bar-value")
      .data(data)
      .enter()
      .append("text")
      .attr("class", "bar-value")
      .attr("x", (d, i) => x(i) + barOffset + barWidth / 2)
      .attr("y", d => y(d.accuracy) - 10)
      .attr("text-anchor", "middle")
      .attr("fill", "#50555F")
      .style("font-size", "14px")
      .style("font-weight", "500")
      .text(d => d.accuracy.toFixed(1));
  };

  const createWeeklyLearningTimeChart = () => {
    if (!weeklyLearningTimeChartRef.current) return;

    d3.select(weeklyLearningTimeChartRef.current).selectAll("*").remove();

    const data = weeklyLearningData2.map(item => ({
      week: item.date,
      time: item.learningTimeMinutes
    }));

    const margin = { top: 40, right: 30, bottom: 50, left: 50 };
    const width = 900 - margin.left - margin.right;
    const height = 280 - margin.top - margin.bottom;

    const svg = d3.select(weeklyLearningTimeChartRef.current)
      .append("svg")
      .attr("width", 900)
      .attr("height", 280)
      .append("g")
      .attr("transform", `translate(${margin.left},${margin.top})`);

    const x = d3.scaleBand()
      .domain(d3.range(data.length))
      .range([0, width])
      .padding(0.5);

    const barWidth = 24;
    const barOffset = (x.bandwidth() - barWidth) / 2;

    const maxTime = d3.max(data, d => d.time) || 5;
    const yMax = maxTime <= 6 ? maxTime : Math.ceil(maxTime / 5) * 5;
    const y = d3.scaleLinear()
      .domain([0, yMax])
      .range([height, 0]);

    const yTicks = maxTime <= 6 ? d3.range(0, yMax + 1) : y.ticks(6);

    svg.selectAll("line.horizontalGrid")
      .data(yTicks)
      .enter()
      .append("line")
      .attr("class", "horizontalGrid")
      .attr("x1", 0)
      .attr("x2", width)
      .attr("y1", d => y(d))
      .attr("y2", d => y(d))
      .attr("stroke", "#E8E8E8")
      .attr("stroke-width", 1);

    svg.selectAll(".y-label")
      .data(yTicks)
      .enter()
      .append("text")
      .attr("class", "y-label")
      .attr("x", -10)
      .attr("y", d => y(d))
      .attr("dy", "0.32em")
      .attr("text-anchor", "end")
      .attr("fill", "#50555F")
      .style("font-size", "16px")
      .style("font-weight", "500")
      .text(d => d + "분");

    svg.append("line")
      .attr("x1", 0)
      .attr("x2", width)
      .attr("y1", height)
      .attr("y2", height)
      .attr("stroke", "#E8E8E8")
      .attr("stroke-width", 1);

    svg.selectAll(".x-label")
      .data(data)
      .enter()
      .append("text")
      .attr("class", "x-label")
      .attr("x", (d, i) => x(i) + x.bandwidth() / 2)
      .attr("y", height + 30)
      .attr("text-anchor", "middle")
      .attr("fill", "#50555F")
      .style("font-size", "16px")
      .style("font-weight", "500")
      .text(d => d.week);

    svg.selectAll(".bar")
      .data(data)
      .enter()
      .append("path")
      .attr("class", "bar")
      .attr("d", (d, i) => {
        if (d.time === 0) return "";

        const x0 = x(i) + barOffset;
        const y0 = y(d.time);
        const cornerRadius = 12;

        return `
          M ${x0},${height}
          L ${x0},${y0 + cornerRadius}
          Q ${x0},${y0} ${x0 + cornerRadius},${y0}
          L ${x0 + barWidth - cornerRadius},${y0}
          Q ${x0 + barWidth},${y0} ${x0 + barWidth},${y0 + cornerRadius}
          L ${x0 + barWidth},${height}
          Z
        `;
      })
             .attr("fill", "#FFD67D");

    svg.selectAll(".bar-value")
      .data(data)
      .enter()
      .append("text")
      .attr("class", "bar-value")
      .attr("x", (d, i) => x(i) + barOffset + barWidth / 2)
      .attr("y", d => y(d.time) - 10)
      .attr("text-anchor", "middle")
      .attr("fill", "#50555F")
      .style("font-size", "14px")
      .style("font-weight", "500")
      .text(d => d.time);
  };

  const processRecordsData = () => {
    if (!monthlyData?.thisMonthRecords) return;

    // 레벨별 데이터 처리
    const levelCounts = {};
    const levelChapterCounts = {};

    monthlyData.thisMonthRecords.forEach(record => {
      // 레벨별 집계
      if (!levelCounts[record.level]) {
        levelCounts[record.level] = 0;
      }
      levelCounts[record.level]++;

      // 레벨-챕터별 집계
      const key = `${record.level}-${record.chapterSeq}`;
      if (!levelChapterCounts[key]) {
        levelChapterCounts[key] = {
          level: record.level,
          chapter: record.chapterSeq,
          chapterName: record.lessonChapterTitle,
          count: 0
        };
      }
      levelChapterCounts[key].count++;
    });

    // 레벨 데이터 생성 (파이 차트용)
    const colors = ['#e74c3c', '#3498db', '#f39c12', '#27ae60', '#9b59b6', '#1abc9c', '#ff9ff3', '#f368e0', '#17a2b8', '#6c757d'];
    const levelPieData = Object.entries(levelCounts).map(([level, count], index) => ({
      id: `레벨 ${level}`,
      label: `레벨 ${level}`,
      value: count,
      color: colors[index % colors.length]
    }));

    setLevelData(levelPieData);

    // 기존 레벨 데이터 (바 차트용)
    const levelBarData = Object.entries(levelCounts).map(([level, count], index) => ({
      id: parseInt(level),
      value: count,
      color: colors[index % colors.length],
      percent: Math.round((count / monthlyData.thisMonthRecords.length) * 100)
    }));

    setLevelData2(levelBarData);

    // 가장 많이 학습한 레벨
    const maxLevelEntry = Object.entries(levelCounts).reduce((max, [level, count]) =>
      count > max.count ? { level: parseInt(level), count } : max, { level: 0, count: 0 });
    setMaxLevel(maxLevelEntry.level);

    // 레벨-챕터 데이터 생성
    const levelChapterData = Object.values(levelChapterCounts).map((item, index) => ({
      ...item,
      value: item.count,
      color: colors[index % colors.length],
      percent: Math.round((item.count / monthlyData.thisMonthRecords.length) * 100)
    }));

    setLevelAndChapterData2(levelChapterData);

    // 가장 많이 학습한 레벨-챕터
    const maxChapterEntry = Object.values(levelChapterCounts).reduce((max, item) =>
      item.count > max.count ? item : max, { level: 0, chapter: 0, chapterName: "", count: 0 });
    setLevelAndChapterMaxLevel(maxChapterEntry.level);
    setLevelAndChapterMaxChapter(maxChapterEntry.chapter);
    setLevelAndChapterMaxChapterName(maxChapterEntry.chapterName);

    // 상세 학습 결과 데이터 변환
    const learningData = monthlyData.thisMonthRecords.map(record => {
      const date = new Date(record.dateTime);
      return {
        month: String(date.getMonth() + 1).padStart(2, '0'),
        day: String(date.getDate()).padStart(2, '0'),
        learningMode: getLearningModeKorean(record.sourceType),
        level: record.level,
        chapter: record.chapterSeq,
        unitName: record.stageName,
        learningTimeSeconds: record.studySeconds,
        grade: record.grade,
        accuracy: Math.round(record.accuracy)
      };
    });

    // 상세 학습 결과 테이블용 데이터
    const recordsTableData = monthlyData.thisMonthRecords.map(record => ({
      courseName: record.lessonChapterTitle || record.stageName,
      levelName: `레벨 ${record.level}`,
      chapterName: `챕터 ${record.chapterSeq}`,
      accuracy: Math.round(record.accuracy),
      grade: record.grade,
      sourceType: record.sourceType
    }));

    setRecordsData(recordsTableData);

    setLearningData2(learningData.slice(0, 16));
    setLearningData3(learningData.slice(16));
    setNumberOfLearningData(Math.ceil(Math.max(0, learningData.length - 16) / 23));

    // 트로피 개수 계산
    let onePercent = 0, tenPercent = 0, thirtyPercent = 0, fiftyPercent = 0, good = 0;

    learningData.forEach(record => {
      if (record.grade === 1) onePercent++;
      else if (record.grade === 10) tenPercent++;
      else if (record.grade === 30) thirtyPercent++;
      else if (record.grade === 50) fiftyPercent++;
      else good++;
    });

    setOnePercentTrophy(onePercent);
    setTenPercentTrophy(tenPercent);
    setThirtyPercentTrophy(thirtyPercent);
    setFiftyPercentTrophy(fiftyPercent);
    setGoodTrophy(good);

    // 우수/취약 스테이지 처리
    processExcellentAndWeakStages(learningData);
  };

  const getLearningModeKorean = (sourceType) => {
    const modeMap = {
      'LESSON': '수업 학습',
      'HOMEWORK': '숙제',
      'DAILY': '오늘의 학습',
      'FREE': '자유 학습',
      'CHALLENGE': '챌린지'
    };
    return modeMap[sourceType] || sourceType;
  };

  const processExcellentAndWeakStages = (learningData) => {
    // 원본 데이터에서 우수/취약 스테이지 처리
    const stageData = monthlyData.thisMonthRecords.map(record => {
      const date = new Date(record.dateTime);
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      
      // 레벨을 학년/학기로 변환
      const grade = Math.ceil(record.level / 2);
      const semester = (record.level % 2 === 0) ? 2 : 1;
      const levelName = `${grade}학년 ${semester}학기`;
      
      return {
        courseName: record.lessonChapterTitle || record.stageName,
        levelName: levelName,
        chapterName: record.chapterName,
        stageName: record.stageName,
        accuracy: Math.round(record.accuracy),
        grade: record.grade,
        lessonTitle: record.lessonTitle !== null ? record.lessonTitle : null,
        lessonChapterTitle: record.lessonChapterTitle !== null ? record.lessonChapterTitle : null,
        learningDateTime: `${month}월${day}일\n${hours}:${minutes}`,
        sourceType: record.sourceType
      };
    });

    // 우수 스테이지 (정확도 90% 이상, grade 낮은 순, 같은 grade면 accuracy 높은 순, 같은 accuracy면 최근 날짜 순)
    const excellentStages = stageData
      .filter(record => record.accuracy >= 90)
      .sort((a, b) => a.grade - b.grade || b.accuracy - a.accuracy || new Date(b.dateTime) - new Date(a.dateTime))
      .slice(0, 5);

    setExcellentLearningData(excellentStages);

    // 취약 스테이지 (정확도 70% 미만, accuracy 낮은 순, 같은 accuracy면 grade 높은->낮은 순)
    const weakStages = stageData
      .filter(record => record.accuracy < 70)
      .sort((a, b) => a.accuracy - b.accuracy || b.grade - a.grade)
      .slice(0, 5);

    setWeekLearningData(weakStages);
  };

  if (!monthlyData || !studentInfo) {
    return <div>데이터를 불러오는 중...</div>;
  }

  const year = selectedMonth.year;
  const month = String(selectedMonth.month).padStart(2, '0');

  // 시간 포맷팅 함수 (초를 시:분 형태로)
  const formatStudyTime = (seconds) => {
    if (!seconds || seconds === 0) return '0초';

    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const second = Math.floor(seconds % 60);

    // 1분 미만이면 초만 표시
    if (seconds < 60) {
      return (
        <>
          {second}
          <span className="text-[14px]">초</span>
        </>
      );
    }

    return (
        <>
          {hours > 0 && (
              <>
                {hours}
                <span className="text-[14px]">시간</span>
              </>
          )}
          {minutes > 0 && (
              <>
                {minutes}
                <span className="text-[14px]">분</span>
              </>
          )}
          {second > 0 && (
              <>
                {second}
                <span className="text-[14px]">초</span>
              </>
          )}
        </>
    );
  };

  // 월별 데이터에서 현재 월 데이터 추출
  const getCurrentMonthKey = () => {
    return `${selectedMonth.year}-${String(selectedMonth.month).padStart(2, '0')}`;
  };

  const currentMonthKey = getCurrentMonthKey();
  const currentMonthData = {
    totalStudyTime: monthlyData?.monthlyTotalStudyTime?.[currentMonthKey] || 0,
    averageAccuracy: monthlyData?.monthlyAverageAccuracy?.[currentMonthKey] || 0,
    stageCnt: monthlyData?.monthlyStageCnt?.[currentMonthKey] || 0,
    solveCnt: monthlyData?.monthlySolveCnt?.[currentMonthKey] || 0
  };

  // 요일 이름 배열
  const dayNames = ['일', '월', '화', '수', '목', '금', '토'];

  // 달력 생성
  const generateCalendar = () => {
    const year = selectedMonth.year;
    const month = selectedMonth.month;
    const firstDay = new Date(year, month - 1, 1);
    const lastDay = new Date(year, month, 0);
    const daysInMonth = lastDay.getDate();
    const startDayOfWeek = firstDay.getDay();

    const calendar = [];
    let week = [];

    // 첫 주의 빈 칸들
    for (let i = 0; i < startDayOfWeek; i++) {
      week.push(null);
    }

    // 날짜들 채우기
    for (let day = 1; day <= daysInMonth; day++) {
      const learningCount = monthlyData?.dailyLearningCounts?.[day] || 0;
      week.push({ day, learningCount });

      if (week.length === 7) {
        calendar.push(week);
        week = [];
      }
    }

    // 마지막 주의 빈 칸들
    while (week.length < 7 && week.length > 0) {
      week.push(null);
    }
    if (week.length > 0) {
      calendar.push(week);
    }

    return calendar;
  };

  // 학습 빈도에 따른 색상 클래스
  const getLearningIntensityClass = (count) => {
    if (count === 0) return 'bg-gray-100';
    if (count <= 2) return 'bg-blue-200';
    if (count <= 5) return 'bg-blue-400';
    if (count <= 10) return 'bg-blue-600';
    return 'bg-blue-800';
  };

  // 학습 빈도에 따른 텍스트 색상
  const getLearningTextClass = (count) => {
    if (count === 0) return 'text-gray-600';
    if (count <= 2) return 'text-gray-800';
    return 'text-white';
  };

  return (
    <div className="text-[18px] mb-16">
      {/* 표지 페이지 */}
      <div className="pring:mt-0" style={{ pageBreakAfter: 'always' }}>
        <div className="relative w-full">
          <div className="relative bg-[#ffffff] shadow-md print:shadow-none rounded w-[1040px] h-[1400px] mx-auto" style={{ backgroundImage: `url(${monthlyReportBg})` }}>
            <div className="relative h-full text-center">
              <div className="text-[#50555F] font-[500] pt-[264px] text-[40px] relative">
                {year}.{month}
              </div>
              <div className="relative mt-[122px] text-center">
                <img
                    src={logoMonthlyReport}
                    className="w-fit mx-auto"
                    alt="logo"
                />
              </div>
              <div className="font-[700] text-[#355BDF] text-[100px] mt-[8px]">
                학습 보고서
              </div>
              <div className="mt-[33px] text-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="500" height="6" viewBox="0 0 500 6" fill="none" className="mx-auto">
                  <path d="M0 3H500" stroke="#355BDF" strokeWidth="5"/>
                </svg>
              </div>
              <div className="text-[30px] font-[500] text-[#50555F] mt-[35px]">
                {schoolName} / {mainClass?.name || ''}
              </div>
                          <div className="text-[40px] font-[500] text-[#50555F] mt-[12px]">
              {studentName}
            </div>
            </div>
          </div>
        </div>

        {/* 출석 현황 페이지 */}
        <div className="mt-[60px] relative w-full" style={{ pageBreakAfter: 'always' }}>
        <div className="relative bg-[#ffffff] w-[1040px] h-[1400px] shadow-md print:shadow-none rounded mx-auto">
            {/* 최상단 연.월 표시 */}
            <div className="relative pt-[58px]">
              <div className="w-[940px] h-[58px] bg-[#F6F6F6] relative mx-auto leading-[58px] text-[32px] pl-[20px] font-[700] text-[#9BA5C2] text-left">
                {year}.{month}
              </div>
            </div>
            <div className="text-[32px] font-bold text-[#50555F] text-center mt-[33px]">
              출석 현황
            </div>
            <div className="relative w-full">
              <div className="relative w-full text-[24px] font-semibold text-[#9C9C9C] mt-[50px] h-[40px]">
                <div className="absolute left-[60px] top-0 w-[130px] h-[40px] text-[#EF9999] text-center leading-[40px]">일</div>
                <div className="absolute left-[190px] top-0 w-[130px] h-[40px] text-center leading-[40px]">월</div>
                <div className="absolute left-[320px] top-0 w-[130px] h-[40px] text-center leading-[40px]">화</div>
                <div className="absolute left-[450px] top-0 w-[130px] h-[40px] text-center leading-[40px]">수</div>
                <div className="absolute left-[580px] top-0 w-[130px] h-[40px] text-center leading-[40px]">목</div>
                <div className="absolute left-[710px] top-0 w-[130px] h-[40px] text-center leading-[40px]">금</div>
                <div className="absolute left-[840px] top-0 w-[130px] h-[40px] text-center leading-[40px]">토</div>
              </div>
            </div>

            <div className="relative w-full">
              <div className="w-[920px] mx-auto my-[11px]">
                {calendarData && calendarData.map((week, weekIndex) => (
                  <div key={weekIndex} className={`relative w-full h-[130px] ${weekIndex===0 ? "border-t-[1px]" : ""}`}>
                    {week.map((day, dayIndex) => (
                      <div key={dayIndex} className="absolute w-[130px] h-[130px] p-[20px]" style={{left: `${dayIndex * 130}px`, top: 0}}>
                        <div className="relative h-full">
                          <div className="absolute top-0 left-1/2 transform -translate-x-1/2">
                            {day.day && (
                                <div
                                    className={`w-[50px] h-[50px] text-[24px] font-[700] rounded-full text-center leading-[50px] ${day.attendanceStatus ? 'bg-[#E5EAFF]' : 'bg-[#fff]'} ${dayIndex === 0 ? 'text-[#C5282B]' : day.day ? 'text-[#50555F]' : 'text-[#adb0b2]'}`}>
                                  {day.day}
                                </div>
                            )}
                          </div>
                          <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2">
                            {day.day && (
                              <div
                                  className={day.learningCount > 0 ? "font-[500] text-right text-[#557CFC] text-[20px]" : "text-right text-[#b6b9bc] text-[20px]"}>
                                {day.learningCount > 0 ? (day.learningCount+"개") : "-"}
                              </div>
                                )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>

          <div className="px-[113px] mt-[50px] text-[#50555F] font-[500] text-[20px] text-left">
            <div className="relative">
              <svg xmlns="http://www.w3.org/2000/svg" width="8" height="16" viewBox="0 0 8 9" fill="none" className="absolute left-0 top-[6px]">
                <circle cx="4" cy="4.48438" r="4" fill="#7494FF"/>
              </svg>
              <div className="ml-[16px]">
                총 출석 일수는 {attendanceCount}일입니다.
              </div>
            </div>
              <div className="relative mt-[20px]">
                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="16" viewBox="0 0 8 9" fill="none" className="absolute left-0 top-[6px]">
                  <circle cx="4" cy="4.48438" r="4" fill="#7494FF"/>
                </svg>
                <div className="ml-[16px]">
                  출석한 날에는 평균 {averageLearningCount}개의 스테이지를 학습했습니다.
                </div>
              </div>
            </div>

            <div className="absolute bottom-[0] right-[0]">
              <div className="w-[100px] h-[100px] relative text-[16px] font-[500] text-[#50555F] text-center leading-[100px]">1</div>
            </div>
          </div>
        </div>

        {/* 평균 학습 현황 페이지 */}
        <div className="mt-[60px] print:mt-0 relative w-full" style={{ pageBreakAfter: 'always' }}>
          <div className="relative bg-[#ffffff] w-[1040px] h-[1400px] shadow-md print:shadow-none rounded mx-auto">
            {/* 최상단 연.월 표시 */}
            <div className="relative pt-[58px]">
              <div
                  className="w-[940px] h-[58px] bg-[#F6F6F6] relative mx-auto leading-[58px] text-[32px] pl-[20px] font-[700] text-[#9BA5C2] text-left">
                {year}.{month}
              </div>
            </div>
            <div className="text-[32px] mt-[33px] font-bold text-[#50555F] text-center">
              평균 학습 현황
            </div>
            <div className="mt-[70px] h-[80px]">
              <div className="mt-[14px]">
                <div className="relative w-full px-[60px]">
                    <div className="absolute left-[118px] top-0 w-[284px]">
                      <div className="relative w-full">
                        <div className="absolute left-[0px] top-[0px] w-[100px] text-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="70" height="71" viewBox="0 0 70 71" fill="none" className="mx-auto">
                            <path
                                d="M61.25 61.9609V42.7902L67.0677 38.4853C69.9812 36.3295 70.5953 32.22 68.4395 29.3065L65.1661 24.8827C64.1727 23.5403 62.7647 22.6861 61.25 22.366V20.3984C61.25 19.8183 61.0195 19.2619 60.6093 18.8516L45.2968 3.53914C44.8866 3.12891 44.3302 2.89844 43.75 2.89844H15.3125C11.6881 2.89844 8.75 5.83657 8.75 9.46094V61.9609C8.75 65.5853 11.6881 68.5234 15.3125 68.5234H54.6875C58.3119 68.5234 61.25 65.5853 61.25 61.9609ZM13.125 61.9609V9.46094C13.125 8.25282 14.1044 7.27344 15.3125 7.27344H41.5625V19.3199C41.5625 21.1237 43.0247 22.5859 44.8285 22.5859H56.875V22.9566C56.5696 23.1151 56.2727 23.2997 55.9872 23.5109L50.2675 27.7433C50.1334 27.2909 49.7146 26.9609 49.2188 26.9609H20.7812C20.1772 26.9609 19.6875 27.4506 19.6875 28.0547C19.6875 28.6587 20.1772 29.1484 20.7812 29.1484H48.3686L42.4562 33.5234H20.7812C20.1772 33.5234 19.6875 34.0131 19.6875 34.6172C19.6875 35.2212 20.1772 35.7109 20.7812 35.7109H39.5L33.5876 40.0859H20.7812C20.1772 40.0859 19.6875 40.5756 19.6875 41.1797C19.6875 41.7837 20.1772 42.2734 20.7812 42.2734H30.6313L24.842 46.5574C24.8026 46.5865 24.7643 46.6169 24.7272 46.6484H20.7812C20.1772 46.6484 19.6875 47.1381 19.6875 47.7422C19.6875 48.3462 20.1772 48.8359 20.7812 48.8359H23.6976L20.559 59.1269C20.3569 59.7897 20.4808 60.5091 20.893 61.0662C21.3052 61.6232 21.9569 61.952 22.6499 61.9525L34.6198 61.9608C35.0888 61.9611 35.5455 61.8107 35.9225 61.5317L56.875 46.0276V61.9609C56.875 63.1691 55.8956 64.1484 54.6875 64.1484H15.3125C14.1044 64.1484 13.125 63.1691 13.125 61.9609ZM44.8285 20.3984C44.2329 20.3984 43.75 19.9156 43.75 19.3199V8.17953L55.9689 20.3984H44.8285ZM57.3906 40.2035L51.5254 32.255L54.0862 30.3601L59.962 38.3008L57.3906 40.2035ZM29.6897 48.4127L49.767 33.5562L55.6322 41.5047L35.7625 56.2076L29.6897 48.4127ZM27.9831 49.7815L34.0035 57.5092L33.9007 57.5853L28.1816 57.5813L26.3566 55.1149L27.9831 49.7815Z"
                                fill="#7494FF"/>
                          </svg>
                        </div>
                        <div className="absolute left-[120px] top-[0px] w-[146px]">
                          <div className="text-[#50555F] text-[21px] font-[700] mt-[-6px] text-left">학습량</div>
                          <div className="mt-[10px] text-left">
                            <span
                                className="text-[30px] font-semibold text-[#355BDF]">{averageLearningCount}</span>
                            <span className="text-[21px] font-semibold text-[#355BDF] ml-[2px]">개</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  <div className="absolute left-[433px] top-0 w-[284px]">
                    <div className="relative w-full">
                      <div className="absolute left-[0px] top-[0px] w-[100px] text-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="71" height="71" viewBox="0 0 71 71" fill="none" className="mx-auto">
                          <path
                              d="M42.466 16.2167C42.4599 16.2139 42.4539 16.2111 42.4479 16.2083C42.4617 17.2536 42.6133 18.297 42.9023 19.3112L43.3398 20.8184L40.8973 22.7668C40.8967 22.7665 40.8978 22.7671 40.8973 22.7668L36.0798 26.6077C33.6688 28.5662 33.0706 31.8798 34.4264 34.4825L32.0754 36.8303C31.3447 37.583 31.3447 38.7689 32.0754 39.5215C32.829 40.2741 34.0165 40.2741 34.7701 39.5215L37.1155 37.1791C39.7227 38.5467 43.0478 37.9491 44.9955 35.5164L50.8282 28.2079L52.4655 28.6855C52.8295 28.7921 53.1961 28.88 53.564 28.9495C54.1678 29.0639 54.7802 29.1292 55.3955 29.1447C55.3955 29.1447 55.3955 29.1448 55.3955 29.1447C58.5802 29.2261 61.7138 27.974 64.0125 25.5877L65.937 23.6042C67.0182 22.5122 66.5425 20.6401 65.0937 20.2167L57.7773 18.2109L57.7735 18.2151C57.795 17.7152 57.7271 17.2129 57.5709 16.7336L59.4004 14.9041C60.153 14.1515 60.153 12.9655 59.4004 12.2129C58.6478 11.4603 57.4619 11.4603 56.7092 12.2129L54.8793 14.0429C54.4002 13.8867 53.8981 13.8187 53.3984 13.8397L53.4023 13.8359L51.2317 6.53621C50.8161 5.07059 48.9786 4.58937 47.9067 5.68312L45.9599 7.62996C43.6493 9.92401 42.4221 13.0399 42.466 16.2167Z"
                              fill="#7494FF"/>
                          <path
                              d="M49.872 32.925L51.6326 30.719L51.8623 30.7846C53.1049 31.1494 54.3932 31.335 55.6883 31.3359C55.8852 31.3351 56.082 31.3301 56.2784 31.3209C57.2491 34.062 57.7773 37.0123 57.7773 40.0859C57.7773 54.5834 46.0248 66.3359 31.5273 66.3359C17.0299 66.3359 5.27734 54.5834 5.27734 40.0859C5.27734 25.5885 17.0299 13.8359 31.5273 13.8359C34.6012 13.8359 37.5516 14.3643 40.2928 15.3351C40.215 16.8715 40.3894 18.4167 40.8155 19.9084L40.8439 20.0134L38.6802 21.7381C36.4631 20.8731 34.0507 20.3984 31.5273 20.3984C20.6542 20.3984 11.8398 29.2128 11.8398 40.0859C11.8398 50.959 20.6542 59.7734 31.5273 59.7734C42.4004 59.7734 51.2148 50.959 51.2148 40.0859C51.2148 37.5596 50.739 35.1444 49.872 32.925Z"
                              fill="#7494FF"/>
                          <path
                              d="M38.0858 39.8549C39.5811 40.2105 41.1478 40.1555 42.6189 39.6916C43.3152 39.472 43.9766 39.165 44.5883 38.7807C44.6306 39.21 44.6523 39.6455 44.6523 40.0859C44.6523 47.3347 38.7761 53.2109 31.5273 53.2109C24.2786 53.2109 18.4023 47.3347 18.4023 40.0859C18.4023 32.8372 24.2786 26.9609 31.5273 26.9609C31.9714 26.9609 32.4103 26.983 32.8431 27.0261C32.462 27.6386 32.1574 28.2997 31.9389 28.9951C31.4768 30.466 31.4186 32.0312 31.7663 33.5277C31.687 33.5249 31.6073 33.5234 31.5273 33.5234C27.903 33.5234 24.9648 36.4616 24.9648 40.0859C24.9648 43.7103 27.903 46.6484 31.5273 46.6484C35.1517 46.6484 38.0898 43.7103 38.0898 40.0859C38.0898 40.0086 38.0885 39.9316 38.0858 39.8549Z"
                              fill="#7494FF"/>
                        </svg>
                      </div>
                      <div className="absolute left-[120px] top-[0px] w-[146px]">
                        <div className="text-[#50555F] text-[21px] font-[700]  mt-[-6px] text-left">정확도</div>
                        <div className="mt-[10px] text-left">
                          <span
                              className="text-[30px] font-semibold text-[#355BDF]">{averageAccuracy}</span>
                          <span className="text-[21px] font-semibold text-[#355BDF] ml-[2px]">%</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="absolute left-[722px] top-0 w-[284px]">
                    <div className="relative w-full">
                      <div className="absolute left-[0px] top-[0px] w-[100px] text-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="70" height="71" viewBox="0 0 70 71" fill="none" className="mx-auto">
                          <path
                              d="M9.34748 21.0612C7.73831 16.0645 9.43219 10.3793 13.7939 7.29245C18.1556 4.2056 23.8301 4.7164 27.6201 8.15857C28.8058 9.24674 28.6787 11.2232 27.3872 12.1337L12.947 22.3269C11.6342 23.2374 9.85564 22.6157 9.34748 21.0612Z"
                              fill="#7494FF"/>
                          <path
                              d="M35 24.9375C36.2081 24.9375 37.1875 25.9169 37.1875 27.125V36.8918L42.7759 40.6174C43.7811 41.2875 44.0527 42.6457 43.3826 43.6509C42.7124 44.6561 41.3543 44.9277 40.3491 44.2576L33.7866 39.8826C33.1441 39.4543 32.8013 38.7449 32.8125 38.0262V27.125C32.8125 25.9169 33.7919 24.9375 35 24.9375Z"
                              fill="#7494FF"/>
                          <path
                              d="M50.7645 54.6425C55.8344 50.4293 59.0625 44.076 59.0625 36.9688C59.0625 24.2835 48.779 14 36.0937 14C23.4084 14 13.125 24.2835 13.125 36.9688C13.125 43.5545 15.8967 49.4928 20.3372 53.6809L14.6811 58.5741C11.6302 61.2239 13.3642 66.5 17.2931 66.5H52.6972C56.6261 66.5 58.382 61.2239 55.3091 58.5741L50.7645 54.6425ZM36.0938 53.375C27.0328 53.375 19.6875 46.0297 19.6875 36.9688C19.6875 27.9079 27.0328 20.5625 36.0938 20.5625C45.1547 20.5625 52.5 27.9079 52.5 36.9688C52.5 46.0297 45.1547 53.375 36.0938 53.375Z"
                              fill="#7494FF"/>
                          <path
                              d="M58.3936 7.29245C62.7553 10.3793 64.4492 16.0645 62.84 21.0612C62.3319 22.6157 60.5533 23.2374 59.2406 22.3269L44.8003 12.1337C43.5088 11.2232 43.3817 9.24674 44.5674 8.15857C48.3574 4.7164 54.0319 4.2056 58.3936 7.29245Z"
                              fill="#7494FF"/>
                        </svg>
                      </div>
                      <div className="absolute left-[120px] top-[0px] w-[146px]">
                        <div className="text-[#50555F] text-[21px] font-[700]  mt-[-6px] text-left">학습시간</div>
                        <div className="mt-[10px] text-left">
                          <span
                              className="text-[30px] font-semibold text-[#355BDF]">{mm(averageLearningTimeSeconds)}</span>
                          {mm(averageLearningTimeSeconds) !== "" && (
                              <span className="text-[21px] font-semibold text-[#355BDF] ml-[2px]">분</span>
                          )}
                          <span
                              className="text-[30px] font-semibold text-[#355BDF] ml-[4px]">{ss(averageLearningTimeSeconds)}</span>
                          {ss(averageLearningTimeSeconds) !== "" && (
                              <span className="text-[21px] font-semibold text-[#355BDF] ml-[2px]">초</span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 총 학습 현황 */}
            <div className="relative mt-[107px] mr-[75px]">
              <div className="absolute right-0 top-[-47px]">
                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9" fill="none" className="absolute left-0 top-[6px]">
                  <circle cx="4" cy="4.48438" r="4" fill="#D3D3D3"/>
                </svg>
                <div className="text-[12px] font-[500] text-[#50555F] ml-[16px] leading-[22px]">
                  출석일 기준 평균
                </div>
              </div>
            </div>
            <div className="mt-[20px] px-[60px]">
              <div className="relative border-t h-[92px]">
                <div className="absolute left-[40px] top-0 w-[270px] h-[92px] leading-[92px] text-[#50555F] font-bold text-[18px] text-left">학습량
                  (스테이지 개수)
                </div>
                <div className="absolute left-[310px] top-0 w-[300px] h-[92px] text-center">
                  <div className="relative top-1/2 transform -translate-y-1/2">
                    <span className="text-[#355BDF] text-[40px] font-[700]">{learningCount}</span>
                    <span className="text-[#355BDF] text-[18px] font-[700]">개</span>
                  </div>
                </div>
                <div className="absolute right-[40px] top-0 w-[370px] h-[92px]">
                  <div className="relative top-1/2 transform -translate-y-1/2 text-right">
                    {!hasPreviousMonthData ? (
                        <div className="text-[#5c5e60] text-[20px]">-</div>
                    ) : preMonthComparisonLearningCount === 0 ? (
                        <div className="relative">
                          <div className="text-[#5c5e60] text-[20px] absolute right-[54px] top-[-12px] text-center">저번 달과 동일</div>
                          <div className="absolute right-0 top-[-12px]">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" className="mt-[2px]"
                                 fill="none">
                              <path
                                  d="M12 13.4844C12.5523 13.4844 13 13.0367 13 12.4844C13 11.9321 12.5523 11.4844 12 11.4844C11.4477 11.4844 11 11.9321 11 12.4844C11 13.0367 11.4477 13.4844 12 13.4844Z"
                                  stroke="#D3D1D1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                              <path
                                  d="M19 13.4844C19.5523 13.4844 20 13.0367 20 12.4844C20 11.9321 19.5523 11.4844 19 11.4844C18.4477 11.4844 18 11.9321 18 12.4844C18 13.0367 18.4477 13.4844 19 13.4844Z"
                                  stroke="#D3D1D1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                              <path
                                  d="M5 13.4844C5.55228 13.4844 6 13.0367 6 12.4844C6 11.9321 5.55228 11.4844 5 11.4844C4.44772 11.4844 4 11.9321 4 12.4844C4 13.0367 4.44772 13.4844 5 13.4844Z"
                                  stroke="#D3D1D1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          </div>
                        </div>
                    ) : preMonthComparisonLearningCount > 0 ? (
                        <div className="relative">
                          <div className="text-[#5c5e60] text-[20px] absolute right-[54px] top-[-12px] text-center">저번
                            달보다 {preMonthComparisonLearningCount}개 증가
                          </div>
                          <div className="absolute right-0 top-[-12px]">
                            <svg xmlns="http://www.w3.org/2000/svg"
                                 className="text-[#17b20e] h-[22px] w-[22px] mt-[2px]" fill="none"
                                 viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                    d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"/>
                            </svg>
                          </div>
                        </div>
                    ) : (
                        <div className="relative">
                          <div className="text-[#5c5e60] text-[20px] absolute right-[54px] top-[-12px] text-center">저번
                            달보다 {Math.abs(preMonthComparisonLearningCount)}개 감소
                          </div>
                          <div className="absolute right-0 top-[-12px]">
                            <svg xmlns="http://www.w3.org/2000/svg"
                                 className="text-[#d61313] h-[22px] w-[22px] mt-[2px]" fill="none"
                                 viewBox="0 0 22 22" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                    d="M13 17h8m0 0V9m0 8l-8-8-4 4-6-6"/>
                            </svg>
                          </div>
                        </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="relative border-t h-[92px]">
                <div className="absolute left-[40px] top-0 w-[270px] h-[92px] leading-[92px] text-[#50555F] font-bold text-[18px] text-left">정확도
                </div>
                <div className="absolute left-[310px] top-0 w-[300px] h-[92px] text-center">
                  <div className="relative top-1/2 transform -translate-y-1/2">
                    <span className="text-[#355BDF] text-[40px] font-[700]">{averageAccuracy}</span>
                    <span className="text-[#355BDF] text-[18px] font-[700]">%</span>
                  </div>
                </div>
                <div className="absolute right-[40px] top-0 w-[370px] h-[92px]">
                  <div className="relative top-1/2 transform -translate-y-1/2 text-right">
                    {!hasPreviousMonthData ? (
                        <div className="text-[#5c5e60] text-[20px]">-</div>
                    ) : preMonthComparisonAccuracy === 0 ? (
                        <div className="relative">
                          <div className="text-[#5c5e60] text-[20px] absolute right-[54px] top-[-12px]">저번 달과 동일</div>
                          <div className="absolute right-0 top-[-12px]">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" className="mt-[2px]"
                                 fill="none">
                              <path
                                  d="M12 13.4844C12.5523 13.4844 13 13.0367 13 12.4844C13 11.9321 12.5523 11.4844 12 11.4844C11.4477 11.4844 11 11.9321 11 12.4844C11 13.0367 11.4477 13.4844 12 13.4844Z"
                                  stroke="#D3D1D1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                              <path
                                  d="M19 13.4844C19.5523 13.4844 20 13.0367 20 12.4844C20 11.9321 19.5523 11.4844 19 11.4844C18.4477 11.4844 18 11.9321 18 12.4844C18 13.0367 18.4477 13.4844 19 13.4844Z"
                                  stroke="#D3D1D1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                              <path
                                  d="M5 13.4844C5.55228 13.4844 6 13.0367 6 12.4844C6 11.9321 5.55228 11.4844 5 11.4844C4.44772 11.4844 4 11.9321 4 12.4844C4 13.0367 4.44772 13.4844 5 13.4844Z"
                                  stroke="#D3D1D1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          </div>
                        </div>
                    ) : preMonthComparisonAccuracy > 0 ? (
                        <div className="relative">
                          <div className="text-[#5c5e60] text-[20px] absolute right-[54px] top-[-12px]">저번
                            달보다 {preMonthComparisonAccuracy}%
                            증가
                          </div>
                          <div className="absolute right-0 top-[-12px]">
                            <svg xmlns="http://www.w3.org/2000/svg"
                                 className="text-[#17b20e] h-[22px] w-[22px] mt-[2px]" fill="none"
                                 viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                    d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"/>
                            </svg>
                          </div>
                        </div>
                    ) : (
                        <div className="relative">
                          <div className="text-[#5c5e60] text-[20px] absolute right-[54px] top-[-12px]">저번
                            달보다 {Math.abs(preMonthComparisonAccuracy)}% 감소
                          </div>
                          <div className="absolute right-0 top-[-12px]">
                            <svg xmlns="http://www.w3.org/2000/svg"
                                 className="text-[#d61313] h-[22px] w-[22px] mt-[2px]" fill="none"
                                 viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                    d="M13 17h8m0 0V9m0 8l-8-8-4 4-6-6"/>
                            </svg>
                          </div>
                        </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="relative border-t h-[92px]">
                <div className="absolute left-[40px] top-0 w-[270px] h-[92px] leading-[92px] text-[#50555F] font-bold text-[18px] text-left">학습시간
                </div>
                <div className="absolute left-[310px] top-0 w-[300px] h-[92px] text-center">
                  <div className="relative top-1/2 transform -translate-y-1/2">
                    <span
                        className="text-[#355BDF] text-[40px] font-[700]">{formatStudyTime(learningTimeSeconds)}</span>
                  </div>
                </div>
                <div className="absolute right-[40px] top-0 w-[370px] h-[92px]">
                  <div className="relative top-1/2 transform -translate-y-1/2 text-right">
                    {!hasPreviousMonthData ? (
                        <div className="text-[#5c5e60] text-[20px]">-</div>
                    ) : preMonthComparisonLearningTimeSeconds === 0 ? (
                        <div className="relative">
                          <div className="text-[#5c5e60] text-[20px] absolute right-[54px] top-[-12px]">저번 달과 동일</div>
                          <div className="absolute right-0 top-[-12px]">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" className="mt-[2px]"
                                 fill="none">
                              <path
                                  d="M12 13.4844C12.5523 13.4844 13 13.0367 13 12.4844C13 11.9321 12.5523 11.4844 12 11.4844C11.4477 11.4844 11 11.9321 11 12.4844C11 13.0367 11.4477 13.4844 12 13.4844Z"
                                  stroke="#D3D1D1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                              <path
                                  d="M19 13.4844C19.5523 13.4844 20 13.0367 20 12.4844C20 11.9321 19.5523 11.4844 19 11.4844C18.4477 11.4844 18 11.9321 18 12.4844C18 13.0367 18.4477 13.4844 19 13.4844Z"
                                  stroke="#D3D1D1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                              <path
                                  d="M5 13.4844C5.55228 13.4844 6 13.0367 6 12.4844C6 11.9321 5.55228 11.4844 5 11.4844C4.44772 11.4844 4 11.9321 4 12.4844C4 13.0367 4.44772 13.4844 5 13.4844Z"
                                  stroke="#D3D1D1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          </div>
                        </div>
                    ) : preMonthComparisonLearningTimeSeconds > 0 ? (
                        <div className="relative">
                          <div className="text-[#5c5e60] text-[20px] absolute right-[54px] top-[-12px]">저번
                            달보다 {formatStudyTime(preMonthComparisonLearningTimeSeconds)} 증가
                          </div>
                          <div className="absolute right-0 top-[-12px]">
                            <svg xmlns="http://www.w3.org/2000/svg"
                                 className="text-[#17b20e] h-[22px] w-[22px] mt-[2px]" fill="none"
                                 viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                    d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"/>
                            </svg>
                          </div>
                        </div>
                    ) : (
                        <div className="relative">
                          <div className="text-[#5c5e60] text-[20px] absolute right-[54px] top-[-12px]">저번
                            달보다 {formatStudyTime(Math.abs(preMonthComparisonLearningTimeSeconds))} 감소
                          </div>
                          <div className="absolute right-0 top-[-12px]">
                            <svg xmlns="http://www.w3.org/2000/svg"
                                 className="text-[#d61313] h-[22px] w-[22px] mt-[2px]" fill="none"
                                 viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                    d="M13 17h8m0 0V9m0 8l-8-8-4 4-6-6"/>
                            </svg>
                          </div>
                        </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="relative border-t border-b h-[92px]">
                <div className="absolute left-[40px] top-0 w-[270px] h-[92px] leading-[92px] text-[#50555F] font-bold text-[18px] text-left">문제
                  개수
                </div>
                <div className="absolute left-[310px] top-0 w-[300px] h-[92px] text-center">
                  <div className="relative top-1/2 transform -translate-y-1/2">
                    <span className="text-[#355BDF] text-[40px] font-[700]">{problemCount}</span>
                    <span className="text-[#355BDF] text-[18px] font-[700]">개</span>
                  </div>
                </div>
                <div className="absolute right-[40px] top-0 w-[370px] h-[92px]">
                  <div className="relative top-1/2 transform -translate-y-1/2 text-right">
                    {!hasPreviousMonthData ? (
                        <div className="text-[#5c5e60] text-[20px]">-</div>
                    ) : preMonthComparisonProblemCount === 0 ? (
                        <div className="relative">
                          <div className="text-[#5c5e60] text-[20px] absolute right-[54px] top-[-12px]">저번 달과 동일</div>
                          <div className="absolute right-0 top-[-12px]">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" className="mt-[2px]"
                                 fill="none">
                              <path
                                  d="M12 13.4844C12.5523 13.4844 13 13.0367 13 12.4844C13 11.9321 12.5523 11.4844 12 11.4844C11.4477 11.4844 11 11.9321 11 12.4844C11 13.0367 11.4477 13.4844 12 13.4844Z"
                                  stroke="#D3D1D1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                              <path
                                  d="M19 13.4844C19.5523 13.4844 20 13.0367 20 12.4844C20 11.9321 19.5523 11.4844 19 11.4844C18.4477 11.4844 18 11.9321 18 12.4844C18 13.0367 18.4477 13.4844 19 13.4844Z"
                                  stroke="#D3D1D1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                              <path
                                  d="M5 13.4844C5.55228 13.4844 6 13.0367 6 12.4844C6 11.9321 5.55228 11.4844 5 11.4844C4.44772 11.4844 4 11.9321 4 12.4844C4 13.0367 4.44772 13.4844 5 13.4844Z"
                                  stroke="#D3D1D1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          </div>
                        </div>
                    ) : preMonthComparisonProblemCount > 0 ? (
                        <div className="relative">
                          <div className="text-[#5c5e60] text-[20px] absolute right-[54px] top-[-12px]">저번
                            달보다 {preMonthComparisonProblemCount}개 증가
                          </div>
                          <div className="absolute right-0 top-[-12px]">
                            <svg xmlns="http://www.w3.org/2000/svg"
                                 className="text-[#17b20e] h-[22px] w-[22px] mt-[2px]" fill="none"
                                 viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                    d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"/>
                            </svg>
                          </div>
                        </div>
                    ) : (
                        <div className="relative">
                          <div className="text-[#5c5e60] text-[20px] absolute right-[54px] top-[-12px]">저번
                            달보다 {Math.abs(preMonthComparisonProblemCount)}개 감소
                          </div>
                          <div className="absolute right-0 top-[-12px]">
                            <svg xmlns="http://www.w3.org/2000/svg"
                                 className="text-[#d61313] h-[22px] w-[22px] mt-[2px]" fill="none"
                                 viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                    d="M13 17h8m0 0V9m0 8l-8-8-4 4-6-6"/>
                            </svg>
                          </div>
                        </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* 학습 모드별 비율 섹션 */}
            <div
                className="text-[32px] font-bold text-[#50555F] mt-[72px] px-[60px]">
              학습 모드별 비율
            </div>

            <div className="mt-[49px] px-[60px] text-[#50555F] font-[700]">
                <div className="relative h-[30px] mb-[30px]">
                 <div className="absolute left-0 top-0 h-[30px] w-[120px] pl-[6px]">
                   <div className="w-[0.625rem] h-[0.625rem] bg-[#7494FF] rounded-full absolute left-[6px] top-[10px]"></div>
                   <div className="ml-[24px] leading-[30px] text-left">
                     <span>학교 수업</span>
                   </div>
                 </div>
                 <div className="absolute left-[162px] top-0 w-[70px] h-[30px] leading-[30px]">
                   <span>{lessonModePercent}%</span>
                 </div>
                 <div className="absolute left-[274px] top-0 w-[672px] h-[30px] pr-[10px]">
                   <div className="overflow-hidden">
                     <div className="relative w-full bg-[#e8e9ea] rounded-full h-[30px]">
                       <div className="bg-[#7494FF] h-[30px] rounded-full" style={{width: lessonModePercent + "%"}}></div>
                     </div>
                   </div>
                 </div>
               </div>

                <div className="relative h-[30px] mb-[30px]">
                 <div className="absolute left-0 top-0 h-[30px] w-[120px] pl-[6px]">
                   <div className="w-[0.625rem] h-[0.625rem] bg-[#FF8481] rounded-full absolute left-[6px] top-[10px]"></div>
                   <div className="ml-[24px] leading-[30px] text-left">
                     <span>학교 숙제</span>
                   </div>
                 </div>
                 <div className="absolute left-[162px] top-0 w-[70px] h-[30px] leading-[30px]">
                   <span>{homeworkModePercent}%</span>
                 </div>
                 <div className="absolute left-[274px] top-0 w-[672px] h-[30px] pr-[10px]">
                   <div className="overflow-hidden">
                     <div className="relative w-full bg-[#e8e9ea] rounded-full h-[30px]">
                       <div className="bg-[#FF8481] h-[30px] rounded-full"
                            style={{width: homeworkModePercent + "%"}}></div>
                     </div>
                   </div>
                 </div>
               </div>

                <div className="relative h-[30px] mb-[30px]">
                 <div className="absolute left-0 top-0 h-[30px] w-[120px] pl-[6px]">
                   <div className="w-[0.625rem] h-[0.625rem] bg-[#D699FF] rounded-full absolute left-[6px] top-[10px]"></div>
                   <div className="ml-[24px] leading-[30px] text-left">
                     <span>오늘의 학습</span>
                   </div>
                 </div>
                 <div className="absolute left-[162px] top-0 w-[70px] h-[30px] leading-[30px]">
                   <span>{dailyModePercent}%</span>
                 </div>
                 <div className="absolute left-[274px] top-0 w-[672px] h-[30px] pr-[10px]">
                   <div className="overflow-hidden">
                     <div className="relative w-full bg-[#e8e9ea] rounded-full h-[30px]">
                       <div className="bg-[#D699FF] h-[30px] rounded-full" style={{width: dailyModePercent + "%"}}></div>
                     </div>
                   </div>
                 </div>
               </div>
                 <div className="relative h-[30px] mb-[30px]">
                 <div className="absolute left-0 top-0 h-[30px] w-[120px] pl-[6px]">
                   <div className="w-[0.625rem] h-[0.625rem] bg-[#FFD67D] rounded-full absolute left-[6px] top-[10px]"></div>
                   <div className="ml-[24px] leading-[30px] text-left">
                     <span>일프로도전</span>
                   </div>
                 </div>
                 <div className="absolute left-[162px] top-0 w-[70px] h-[30px] leading-[30px]">
                   <span>{challengeModePercent}%</span>
                 </div>
                 <div className="absolute left-[274px] top-0 w-[672px] h-[30px] pr-[10px]">
                   <div className="overflow-hidden">
                     <div className="relative w-full bg-[#e8e9ea] rounded-full h-[30px]">
                       <div className="bg-[#FFD67D] h-[30px] rounded-full"
                            style={{width: challengeModePercent + "%"}}></div>
                     </div>
                   </div>
                 </div>
               </div>

                <div className="relative h-[30px] mb-[30px]">
                 <div className="absolute left-0 top-0 h-[30px] w-[120px] pl-[6px]">
                   <div className="w-[0.625rem] h-[0.625rem] bg-[#74CEB2] rounded-full absolute left-[6px] top-[10px]"></div>
                   <div className="ml-[24px] leading-[30px] text-left">
                     <span>자유 학습</span>
                   </div>
                 </div>
                 <div className="absolute left-[162px] top-0 w-[70px] h-[30px] leading-[30px]">
                   <span>{freeModePercent}%</span>
                 </div>
                 <div className="absolute left-[274px] top-0 w-[672px] h-[30px] pr-[10px]">
                   <div className="overflow-hidden">
                     <div className="relative w-full bg-[#e8e9ea] rounded-full h-[30px]">
                       <div className="bg-[#74CEB2] h-[30px] rounded-full" style={{width: freeModePercent + "%"}}></div>
                     </div>
                   </div>
                 </div>
               </div>
            </div>

            <div className="absolute bottom-[0] right-[0]">
              <div
                  className="w-[100px] h-[100px] text-center leading-[100px] text-[16px] font-[500] text-[#50555F]">2
              </div>
            </div>
          </div>
        </div>

                 {/* 월별 학습 결과 비교 페이지 */}
          <div className="mt-[60px] relative w-full" style={{ pageBreakAfter: 'always' }}>
            <div className="relative bg-[#ffffff] w-[1040px] h-[1400px] shadow-md print:shadow-none rounded mx-auto">
              <div className="relative pt-[58px] text-[32px] font-[700] text-[#50555F] text-center">
                월별 학습 결과 비교
              </div>
              <div className="mt-[13px] relative w-[229px] mx-auto">
                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="8" viewBox="0 0 8 9" fill="none"
                     className="absolute left-0 top-[6px]">
                  <circle cx="4" cy="4.48438" r="4" fill="#D3D3D3"/>
                </svg>
                <div className="text-[12px] font-[500] text-[#50555F] ml-[16px] leading-[22px]">
                  4개월 평균 학습 결과를 비교한 그래프입니다.
                </div>
              </div>
              <div
                  className="text-[24px] mt-[50px] px-[60px] font-[700] text-[#50555F] text-left">
                학습량 <span className="text-[868E9F] text-[16px] font-[500]">(스테이지 개수)</span>
              </div>

              <div className="relative mt-[20px]">
                <div className="w-[900px] h-[280px] mx-auto" ref={learningCountChartRef}>
                </div>
              </div>

              <div
                  className="text-[24px] mt-[50px] px-[60px] font-[700] text-[#50555F] text-left">
                정확도
              </div>

              <div className="relative mt-[20px]">
                <div className="w-[900px] h-[280px] mx-auto" ref={accuracyChartRef}></div>
              </div>

              <div
                  className="text-[24px] mt-[50px] px-[60px] font-[700] text-[#50555F] text-left">
                학습시간
              </div>

              <div className="relative mt-[20px]">
                <div className="w-[900px] h-[280px] mx-auto" ref={learningTimeChartRef}></div>
              </div>

              <div className="absolute bottom-[0] right-[0]">
                <div
                    className="w-[100px] h-[100px] text-center leading-[100px] text-[16px] font-[500] text-[#50555F]">3
                </div>
              </div>
            </div>
          </div>

        {/* 주별 학습 결과 그래프 페이지 */}
        <div className="mt-[60px] relative w-full" style={{pageBreakAfter: 'always'}}>
          <div className="relative bg-[#ffffff] w-[1040px] h-[1400px] shadow-md print:shadow-none rounded mx-auto">
            <div className="relative pt-[58px] text-[32px] font-[700] text-[#50555F] text-center mt-[50px]">
              주별 학습 결과 비교
            </div>
            <div className="mt-[13px] relative w-[155px] mx-auto">
              <svg xmlns="http://www.w3.org/2000/svg" width="9" height="8" viewBox="0 0 8 9" fill="none"
                   className="absolute left-0 top-[6px]">
                <circle cx="4" cy="4.48438" r="4" fill="#D3D3D3"/>
              </svg>
              <div className="text-[12px] font-[500] text-[#50555F] ml-[16px] leading-[22px]">
                {monthlyData?.weeklyRange}
              </div>
            </div>
            <div
                className="text-[24px] mt-[50px] px-[60px] font-[700] text-[#50555F] text-left">
              학습량 <span className="text-[868E9F] text-[16px] font-[500]">(스테이지 개수)</span>
            </div>

            <div className="relative mt-[20px]">
              <div className="w-[900px] h-[280px] mx-auto" ref={weeklyLearningCountChartRef}></div>
            </div>

            <div
                className="text-[24px] mt-[50px] px-[60px] font-[700] text-[#50555F] text-left">
              정확도
            </div>

            <div className="relative mt-[20px]">
              <div className="w-[900px] h-[280px] mx-auto" ref={weeklyAccuracyChartRef}></div>
            </div>

            <div
                className="text-[24px] mt-[50px] px-[60px] font-[700] text-[#50555F] text-left">
              학습시간
            </div>

            <div className="relative mt-[20px]">
              <div className="w-[900px] h-[280px] mx-auto" ref={weeklyLearningTimeChartRef}></div>
            </div>

            <div className="absolute bottom-[0] right-[0]">
              <div className="w-[100px] h-[100px] text-center leading-[100px] text-[16px] font-[500] text-[#50555F]">4
              </div>
            </div>
          </div>
        </div>


        {/* 우수/취약 스테이지 페이지 */}
        <div className="mt-[60px] print:mt-0 relative w-full" style={{pageBreakAfter: 'always'}}>
          <div className="relative bg-[#ffffff] w-[1040px] h-[1400px] shadow-md print:shadow-none rounded mx-auto">
            {/* 최상단 연.월 표시 */}
            <div className="relative pt-[58px]">
              <div
                  className="w-[940px] h-[58px] bg-[#F6F6F6] relative mx-auto leading-[58px] text-[32px] pl-[20px] font-[700] text-[#9BA5C2] text-left">
              {year}.{month}
                </div>
              </div>
              <div className="text-[32px] font-[700] text-[#50555F] text-center mt-[33px]">
                우수/취약 스테이지
              </div>

              <div className="mt-[50px]">
                {/* 우수 스테이지 */}
                <div className="px-[50px]">
                  <div className="text-[24px] font-[700] text-[#50555F] relative">
                    <div className="ml-[15px] text-left">우수 스테이지</div>
                    <img src={report5Smile} alt="smile" className="ml-[37px] mt-[12px]"></img>
                  </div>
                  {excellentLearningData.length > 0 ? (
                    <div className="mt-[20px] rounded-t-[20px] overflow-hidden">
                      {/* 테이블 헤더 */}
                      <div className="bg-[#F0FAF6] relative h-[56px] text-[18px] font-[700] text-[#8FBAAD]">
                        <div className="absolute left-0 top-0 w-[80px] h-[56px] text-center leading-[56px]">순번</div>
                        <div className="absolute left-[80px] top-0 w-[120px] h-[56px] text-center leading-[56px]">학습일시</div>
                        <div className="absolute left-[200px] top-0 w-[110px] h-[56px] text-center leading-[56px]">학습모드</div>
                        <div className="absolute left-[310px] top-0 w-[130px] h-[56px] text-center leading-[56px]">학기/단원</div>
                        <div className="absolute left-[440px] top-0 w-[300px] h-[56px] text-center leading-[56px]">스테이지명</div>
                        <div className="absolute left-[740px] top-0 w-[100px] h-[56px] text-center leading-[56px]">등급</div>
                        <div className="absolute left-[840px] top-0 w-[100px] h-[56px] text-center leading-[56px]">정확도</div>
                      </div>

                      {/* 테이블 내용 */}
                      {excellentLearningData.map((record, index) => (
                          <div key={index} className={`relative h-[72px] text-[14px] border-b border-[#E9E9E9]`}>
                            <div
                                className="absolute left-0 top-0 w-[80px] h-[72px] text-center leading-[72px] border-r border-l border-[#E9E9E9]">{index + 1}</div>
                            <div
                                className="absolute left-[80px] top-0 w-[120px] h-[72px] text-center border-r border-[#E9E9E9] whitespace-pre-line">
                              <div className="leading-[20px] pt-[15px]">{record.learningDateTime}</div>
                            </div>
                            <div
                                className="absolute left-[200px] top-0 w-[110px] h-[72px] text-center border-r border-[#E9E9E9]">
                              <div className="flex justify-center items-center h-full">
                                <img
                                  src={
                                    record.sourceType === 'LESSON' ? modeLesson :
                                    record.sourceType === 'HOMEWORK' ? modeHomeWork :
                                    record.sourceType === 'DAILY' ? modeDaily :
                                    record.sourceType === 'FREE' ? modeFree :
                                    record.sourceType === 'CHALLENGE' ? modeChallenge : modeLesson
                                  }
                                  alt={record.sourceType}
                                />
                              </div>
                            </div>
                            <div
                                className="absolute left-[310px] top-0 w-[130px] h-[72px] text-center border-r border-[#E9E9E9]">
                              {record.lessonChapterTitle ? (
                                  <div className="leading-[20px] pt-[15px]">
                                    <div className="truncate px-2" title={record.levelName}>
                                      {record.levelName}
                                    </div>
                                    <div className="truncate px-2" title={record.lessonChapterTitle}>
                                      {record.lessonChapterTitle}
                                    </div>
                                  </div>
                              ) : (
                                  <div className="leading-[20px] pt-[15px]">
                                    <div className="truncate px-2" title={record.levelName}>
                                      {record.levelName}
                                    </div>
                                    <div className="truncate px-2" title={record.chapterName}>
                                      {record.chapterName}
                                    </div>
                                  </div>)}
                            </div>
                            <div
                                className="absolute left-[440px] top-0 w-[300px] h-[72px] text-center border-r border-[#E9E9E9]">
                              <div className={` ${record.lessonTitle ? "leading-[20px] pt-[15px]" : "leading-[72px]"}`}>
                                {record.lessonTitle && (
                                    <>
                                      <div className="truncate px-2" title={record.lessonTitle}>{record.lessonTitle}</div>
                                    </>
                                )}
                                <div className="truncate px-2" title={record.stageName}>{record.stageName}</div>
                              </div>
                            </div>
                               <div
                                 className="absolute left-[740px] top-0 w-[100px] h-[72px] text-center border-r border-[#E9E9E9] flex items-center justify-center">
                               <img
                                 src={
                                   record.grade === 1 ? grade1 :
                                   record.grade === 10 ? grade2 :
                                   record.grade === 30 ? grade3 :
                                   record.grade === 50 ? grade4 :
                                   grade5
                                 }
                                 className="w-[40px] h-[40px]"
                                 alt={`Grade ${record.grade}`}
                               />
                             </div>
                                                         <div
                                 className={`absolute left-[840px] top-0 w-[100px] h-[72px] text-center border-r border-[#E9E9E9] font-bold ${record.accuracy >= 90 ? 'text-[#7494FF]' : record.accuracy >= 70 ? 'text-[#00B079]' : 'text-[#EF7070]'}`}>
                               <img
                                 src={record.accuracy >= 90 ? iconSmile : record.accuracy >= 70 ? iconSmile2 : iconSmile3}
                                 className="relative mx-auto mt-[8px]"
                                 alt="icon"
                               />
                               <div className="">
                                 {record.accuracy}%
                               </div>
                             </div>
                          </div>
                      ))}
                    </div>
                  ) : (
                      <div className="mt-[20px] bg-[#f8f9fa] rounded-lg p-[20px] text-center text-gray-500">
                        <div className="text-[16px]">우수 스테이지가 없습니다</div>
                      </div>
                  )}
                </div>

                {/* 취약 스테이지 */}
                <div className="px-[50px] mt-[50px]">
                <div className="text-[24px] font-[700] text-[#50555F] relative">
                    <div className="ml-[15px] text-left">취약 스테이지</div>
                    <img src={report5Sad} alt="sad" className="ml-[37px] mt-[12px]"></img>
                  </div>
                  {weekLearningData.length > 0 ? (
                    <div className="mt-[20px] rounded-t-[20px] overflow-hidden">
                      {/* 테이블 헤더 */}
                      <div className="bg-[#FFF4F4] relative h-[56px] text-[18px] font-[700] text-[#C29B9C]">
                        <div className="absolute left-0 top-0 w-[80px] h-[56px] text-center leading-[56px]">순번</div>
                        <div className="absolute left-[80px] top-0 w-[120px] h-[56px] text-center leading-[56px]">학습일시</div>
                        <div className="absolute left-[200px] top-0 w-[110px] h-[56px] text-center leading-[56px]">학습모드</div>
                        <div className="absolute left-[310px] top-0 w-[130px] h-[56px] text-center leading-[56px]">학기/단원</div>
                        <div className="absolute left-[440px] top-0 w-[300px] h-[56px] text-center leading-[56px]">스테이지명</div>
                        <div className="absolute left-[740px] top-0 w-[100px] h-[56px] text-center leading-[56px]">등급</div>
                        <div className="absolute left-[840px] top-0 w-[100px] h-[56px] text-center leading-[56px]">정확도</div>
                      </div>

                      {/* 테이블 내용 */}
                      {weekLearningData.map((record, index) => (
                          <div key={index} className={`relative h-[72px] text-[14px] border-b border-[#E9E9E9]`}>
                            <div
                                className="absolute left-0 top-0 w-[80px] h-[72px] text-center leading-[72px] border-r border-l border-[#E9E9E9]">{index + 1}</div>
                            <div
                                className="absolute left-[80px] top-0 w-[120px] h-[72px] text-center border-r border-[#E9E9E9] whitespace-pre-line">
                              <div className="leading-[20px] pt-[15px]">{record.learningDateTime}</div>
                            </div>
                            <div
                                className="absolute left-[200px] top-0 w-[110px] h-[72px] text-center border-r border-[#E9E9E9]">
                              <div className="flex justify-center items-center h-full">
                                <img
                                    src={
                                      record.sourceType === 'LESSON' ? modeLesson :
                                          record.sourceType === 'HOMEWORK' ? modeHomeWork :
                                              record.sourceType === 'DAILY' ? modeDaily :
                                                  record.sourceType === 'FREE' ? modeFree :
                                                      record.sourceType === 'CHALLENGE' ? modeChallenge : modeLesson
                                    }
                                    alt={record.sourceType}
                                />
                              </div>
                            </div>
                            <div
                                className="absolute left-[310px] top-0 w-[130px] h-[72px] text-center border-r border-[#E9E9E9]">
                              {record.lessonChapterTitle ? (
                                  <div className="leading-[20px] pt-[15px]">
                                    <div className="truncate px-2" title={record.levelName}>
                                      {record.levelName}
                                    </div>
                                    <div className="truncate px-2" title={record.lessonChapterTitle}>
                                      {record.lessonChapterTitle}
                                    </div>
                                  </div>
                              ) : (
                                  <div className="leading-[20px] pt-[15px]">
                                    <div className="truncate px-2" title={record.levelName}>
                                      {record.levelName}
                                    </div>
                                    <div className="truncate px-2" title={record.chapterName}>
                                      {record.chapterName}
                                    </div>
                                  </div>)}
                            </div>
                            <div
                                className="absolute left-[440px] top-0 w-[300px] h-[72px] text-center border-r border-[#E9E9E9]">
                              <div className={` ${record.lessonTitle ? "leading-[20px] pt-[15px]" : "leading-[72px]"}`}>
                                {record.lessonTitle && (
                                    <>
                                      <div className="truncate px-2" title={record.lessonTitle}>{record.lessonTitle}</div>
                                    </>
                                )}
                                <div className="truncate px-2" title={record.stageName}>{record.stageName}</div>
                              </div>
                            </div>
                            <div
                                className="absolute left-[740px] top-0 w-[100px] h-[72px] text-center border-r border-[#E9E9E9] flex items-center justify-center">
                              <img
                                  src={
                                    record.grade === 1 ? grade1 :
                                        record.grade === 10 ? grade2 :
                                            record.grade === 30 ? grade3 :
                                                record.grade === 50 ? grade4 :
                                                    grade5
                                  }
                                  className="w-[40px] h-[40px]"
                                  alt={`Grade ${record.grade}`}
                              />
                            </div>
                            <div
                                className={`absolute left-[840px] top-0 w-[100px] h-[72px] text-center border-r border-[#E9E9E9] font-[700] ${record.accuracy >= 90 ? 'text-[#7494FF]' : record.accuracy >= 70 ? 'text-[#00B079]' : 'text-[#EF7070]'}`}>
                              <img
                                  src={record.accuracy >= 90 ? iconSmile : record.accuracy >= 70 ? iconSmile2 : iconSmile3}
                                  className="relative mx-auto mt-[8px]"
                                  alt="icon"
                              />
                              <div className="">
                                {record.accuracy}%
                              </div>
                            </div>
                          </div>
                      ))}
                    </div>
                  ) : (
                      <div className="mt-[20px] bg-[#f8f9fa] rounded-lg p-[20px] text-center text-gray-500">
                        <div className="text-[16px]">취약 스테이지가 없습니다</div>
                      </div>
                  )}
                </div>
              </div>

            <div className="absolute bottom-[0] right-[0]">
              <div className="w-[100px] h-[100px] text-center leading-[100px] text-[16px] font-[500] text-[#50555F]">5
              </div>
            </div>
          </div>
        </div>

        {/* 학교 학습 결과 상세 페이지 */}
        <div className="mt-[50px] print:mt-0 relative w-full" style={{pageBreakAfter: 'always'}}>
          <div className="relative bg-[#ffffff] w-[1040px] h-[1400px] shadow-md print:shadow-none rounded mx-auto">
            {/* 최상단 연.월 표시 */}
            <div className="relative pt-[58px]">
              <div
                  className="w-[940px] h-[58px] bg-[#F6F6F6] relative mx-auto leading-[58px] text-[32px] pl-[20px] font-[700] text-[#9BA5C2] text-left">
                {year}.{month}
              </div>
            </div>
            <div className="text-[32px] font-bold text-[#50555F] text-center mt-[33px]">
              학습 모드별 상세 학습 결과
            </div>

            {/* 학교 학습 타이틀과 등급 개수 */}
            <div className="mt-[34px] px-[60px]">
              <div className="text-left mb-[20px] relative h-[32px]">
                <img className="w-[32px] h-[32px] absolute left-[25px]" src={schoolIco} alt="학교 아이콘"/>
                <div className="text-[24px] font-[700] text-[#50555F] absolute leading-[35px] left-[61px]">
                학교 학습 등급
                  </div>
                </div>

                {/* 등급별 개수 표시 */}
                <div className="text-center mb-[25px]">
                  <div className="relative inline-block">
                    {[1, 10, 30, 50, 100].map((grade, index) => {
                      const count = monthlyData.thisMonthRecords.filter(record =>
                        (record.sourceType === 'HOMEWORK' || record.sourceType === 'LESSON') &&
                        record.grade === grade
                      ).length;
                      return (
                        <div key={grade} className="relative inline-block mx-[19px]" style={{top: 0}}>
                          <img
                            src={
                              grade === 1 ? grade1 :
                              grade === 10 ? grade2 :
                              grade === 30 ? grade3 :
                              grade === 50 ? grade4 :
                              grade5
                            }
                            alt={`Grade ${grade}`}
                            className="w-[125px] h-[125px] mb-[8px]"
                          />
                          <div className="text-[40px] font-[900] text-[#5E6169] text-center">
                            {count}<span className="text-[20px]">개</span>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>

              {/* 학교 학습 테이블 */}
              <div className="px-[60px]">
                {(() => {
                  const schoolRecords = monthlyData.thisMonthRecords.filter(record =>
                    record.sourceType === 'HOMEWORK' || record.sourceType === 'LESSON'
                  );

                  if (schoolRecords.length === 0) {
                    return (
                      <div className="flex flex-col items-center justify-center p-8 bg-gray-50 rounded-lg">
                        <div className="text-[18px] text-gray-500">이번 달 학교 학습 기록이 없습니다.</div>
                      </div>
                    );
                  }

                  // 첫 번째 페이지는 10개, 추가 페이지는 18개씩
                  const firstPageItems = 10;
                  const displayRecords = schoolRecords.slice(0, firstPageItems);

                  return (
                    <div className="overflow-x-auto rounded-t-[20px] overflow-hidden">
                      <table className="min-w-full bg-white border rounded-lg table-fixed">
                        <thead className="bg-[#F3F7FF] text-[18px] font-[700] text-[#9BA5C2] h-[56px] border border-[#F3F7FF]">
                        <tr className="bg-[#F3F7FF] border-b-0">
                          <th className="py-3 text-center font-[700] text-[#9BA5C2] w-[110px]">학습 일시</th>
                          <th className="py-3 text-center font-[700] text-[#9BA5C2] w-[110px]">학습 모드</th>
                          <th className="py-3 text-center font-[700] text-[#9BA5C2] w-[130px]">차시 단원명</th>
                          <th className="py-3 text-center font-[700] text-[#9BA5C2] w-[300px]">차시명/스테이지명</th>
                          <th className="py-3 text-center font-[700] text-[#9BA5C2] w-[100px]">학습 시간</th>
                          <th className="py-3 text-center font-[700] text-[#9BA5C2] w-[80px]">등급</th>
                          <th className="py-3 text-center font-[700] text-[#9BA5C2] w-[89px]">정확도</th>
                        </tr>
                        </thead>
                        <tbody>
                          {displayRecords
                            .sort((a, b) => {
                              // 1. 모드 우선순위 정의 (LESSON 먼저)
                              const priorityMap = {'LESSON': 1, 'HOMEWORK': 2};
                              const priorityA = priorityMap[a.sourceType] || 99;
                              const priorityB = priorityMap[b.sourceType] || 99;

                              // 2. 우선순위로 정렬
                              if (priorityA !== priorityB) {
                                return priorityA - priorityB;
                              }

                              // 3. 같은 우선순위면 날짜로 정렬
                              return new Date(a.dateTime) - new Date(b.dateTime);
                            })
                            .map((record, index, array) => {
                              // 현재 레코드의 sourceType
                              const currentSourceType = record.sourceType;

                              // 이전 레코드의 sourceType (없으면 null)
                              const prevSourceType = index > 0 ? array[index - 1].sourceType : null;

                              // 새로운 모드 섹션의 시작인지 확인
                              const isNewSection = currentSourceType !== prevSourceType;

                              // 날짜 포맷팅 (시:분만 표시)
                              const formatTime = (dateTimeStr) => {
                                if (!dateTimeStr) return '';

                                const date = new Date(dateTimeStr);
                                const month = String(date.getMonth() + 1).padStart(2, '0');
                                const day = String(date.getDate()).padStart(2, '0');
                                const hours = String(date.getHours()).padStart(2, '0');
                                const minutes = String(date.getMinutes()).padStart(2, '0');

                                return `${month}월${day}일\n${hours}:${minutes}`;
                              };

                              return (
                                <tr
                                  key={index}
                                  className={`h-[72px] ${isNewSection && index > 0 ? 'border-t-2 border-gray-300' : ''}`}
                                >
                                  <td className="py-2 px-1 border-b border-r border-[#E9E9E9] text-center text-[#5E6169] text-[14px] font-[500] whitespace-pre-line">{formatTime(record.dateTime)}</td>
                                  <td className="py-2 px-1 border-b border-r border-[#E9E9E9] text-center text-[#5E6169] text-[14px] font-[500]">
                                    <div className="flex justify-center">
                                      <img
                                        src={
                                          record.sourceType === 'LESSON' ? modeLesson :
                                          record.sourceType === 'HOMEWORK' ? modeHomeWork :
                                          record.sourceType === 'DAILY' ? modeDaily :
                                          record.sourceType === 'FREE' ? modeFree :
                                          record.sourceType === 'CHALLENGE' ? modeChallenge : modeLesson
                                        }
                                        alt={record.sourceType}
                                      />
                                    </div>
                                  </td>
                                  <td className="py-2 px-1 border-b border-r border-[#E9E9E9] text-center truncate text-[#5E6169] text-[14px] font-[500]"
                                      title={record.lessonChapterTitle}>{record.lessonChapterTitle}</td>
                                  <td className="py-2 px-2 border-b border-r border-[#E9E9E9] text-center text-[#5E6169] text-[14px] font-[500]">
                                    <div className="truncate w-[284px]"
                                         title={record.lessonTitle}>{record.lessonTitle}</div>
                                    <div className="truncate w-[284px]"
                                         title={record.stageName}>{record.stageName}</div>
                                  </td>
                                  <td className="py-2 px-1 border-b border-r border-[#E9E9E9] text-center text-[#5E6169] text-[14px] font-[500]">{formatStudyTime(record.studySeconds || 0)}</td>
                                  <td className="py-2 px-1 border-b border-r border-[#E9E9E9] text-center text-[#5E6169] text-[14px] font-[500]">
                                    {record.grade && (
                                      <div className="flex items-center justify-center">
                                        <img
                                          src={
                                            record.grade === 1 ? grade1 :
                                            record.grade === 10 ? grade2 :
                                            record.grade === 30 ? grade3 :
                                            record.grade === 50 ? grade4 :
                                            record.grade === 100 ? grade5 : grade1
                                          }
                                          className="w-[40px] h-[40px]"
                                          alt={`Grade ${record.grade}`}
                                        />
                                      </div>
                                    )}
                                  </td>
                                  <td className="py-1 px-1 border-b border-[#E9E9E9] text-center text-[#5E6169] text-[14px] font-[700]">
                                    {record.accuracy ? (
                                      <div className="flex flex-col items-center justify-center">
                                        <img
                                          src={
                                            record.accuracy >= 90 ? iconSmile :
                                            record.accuracy >= 70 ? iconSmile2 :
                                            iconSmile3
                                          }
                                          alt="accuracy icon"
                                          className="w-8 h-8"
                                        />
                                        <span
                                          style={{
                                            color: record.accuracy >= 90 ? '#7494FF' :
                                                   record.accuracy >= 70 ? '#00B079' : '#EF7070'
                                          }}
                                        >
                                          {record.accuracy.toFixed(0)}%
                                        </span>
                                      </div>
                                    ) : '-'}
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                  );
                })()}
              </div>

                          <div className="absolute bottom-[0] right-[0]">
              <div className="w-[100px] h-[100px] text-center leading-[100px] text-[16px] font-[500] text-[#50555F]">6</div>
            </div>
            </div>
          </div>

          {/* 학교 학습 결과 추가 페이지 (20개 초과 시) */}
          {(() => {
            const schoolRecords = monthlyData.thisMonthRecords.filter(record =>
              record.sourceType === 'HOMEWORK' || record.sourceType === 'LESSON'
            );

            if (schoolRecords.length <= 10) return null;

            const remainingRecords = schoolRecords.slice(10);
            const additionalPages = Math.ceil(remainingRecords.length / 13);

            return Array.from({ length: additionalPages }, (_, pageIndex) => {
              const startIndex = pageIndex * 13;
              const endIndex = Math.min(startIndex + 13, remainingRecords.length);
              const pageRecords = remainingRecords.slice(startIndex, endIndex);
              const pageNumber = 7 + pageIndex; // 7페이지부터 시작

              return (
                <div key={`school-page-${pageIndex}`} className="mt-[60px] print:mt-0 relative w-full" style={{ pageBreakAfter: 'always' }}>
                  <div className="relative bg-[#ffffff] w-[1040px] h-[1400px] shadow-md print:shadow-none rounded mx-auto">
                    {/* 최상단 연.월 표시 */}
                    <div className="relative pt-[58px]">
                      <div className="w-[940px] h-[58px] bg-[#F6F6F6] relative mx-auto leading-[58px] text-[32px] pl-[20px] font-[700] text-[#9BA5C2] text-left">
                        {year}.{month}
                      </div>
                    </div>
                    <div className="text-[32px] font-bold text-[#50555F] text-center mt-[33px]">
                      학교 학습 결과 {pageIndex + 2}
                    </div>

                    <div className="mt-[50px] px-[60px]">
                      <div className="overflow-x-auto rounded-t-[20px] overflow-hidden">
                        <table className="min-w-full bg-white border rounded-lg table-fixed">
                          <thead className="bg-[#F3F7FF] text-[18px] font-[700] text-[#9BA5C2] h-[56px] border border-[#F3F7FF]">
                            <tr className="bg-[#F3F7FF] border-b-0">
                              <th className="py-3 text-center font-[700] text-[#9BA5C2] w-[110px]">학습 일시</th>
                              <th className="py-3 text-center font-[700] text-[#9BA5C2] w-[110px]">학습 모드</th>
                              <th className="py-3 text-center font-[700] text-[#9BA5C2] w-[130px]">차시 단원명</th>
                              <th className="py-3 text-center font-[700] text-[#9BA5C2] w-[300px]">차시명/스테이지명</th>
                              <th className="py-3 text-center font-[700] text-[#9BA5C2] w-[100px]">학습 시간</th>
                              <th className="py-3 text-center font-[700] text-[#9BA5C2] w-[80px]">등급</th>
                              <th className="py-3 text-center font-[700] text-[#9BA5C2] w-[89px]">정확도</th>
                            </tr>
                          </thead>
                          <tbody>
                            {pageRecords.map((record, index) => {
                              const globalIndex = 10 + startIndex + index + 1; // 첫 페이지 10개 이후 순번
                              
                              // 날짜 포맷팅 함수
                              const formatTime = (dateTimeStr) => {
                                if (!dateTimeStr) return '';
                                const date = new Date(dateTimeStr);
                                const month = String(date.getMonth() + 1).padStart(2, '0');
                                const day = String(date.getDate()).padStart(2, '0');
                                const hours = String(date.getHours()).padStart(2, '0');
                                const minutes = String(date.getMinutes()).padStart(2, '0');
                                return `${month}월${day}일\n${hours}:${minutes}`;
                              };
                              
                              return (
                                <tr key={index} className="h-[72px]">
                                  <td className="py-2 px-1 border-b border-r border-[#E9E9E9] text-center text-[#5E6169] text-[14px] font-[500] whitespace-pre-line">{formatTime(record.dateTime)}</td>
                                  <td className="py-2 px-1 border-b border-r border-[#E9E9E9] text-center text-[#5E6169] text-[14px] font-[500]">
                                    <div className="flex justify-center">
                                      <img
                                        src={
                                          record.sourceType === 'LESSON' ? modeLesson :
                                          record.sourceType === 'HOMEWORK' ? modeHomeWork :
                                          record.sourceType === 'DAILY' ? modeDaily :
                                          record.sourceType === 'FREE' ? modeFree :
                                          record.sourceType === 'CHALLENGE' ? modeChallenge : modeDaily
                                        }
                                        alt={record.sourceType}
                                      />
                                    </div>
                                  </td>
                                  <td className="py-2 px-1 border-b border-r border-[#E9E9E9] text-center text-[#5E6169] text-[14px] font-[500]"
                                      title={record.lessonChapterTitle}
                                  >
                                    {record.lessonChapterTitle}
                                  </td>
                                  <td className="py-2 px-2 border-b border-r border-[#E9E9E9] text-center text-[#5E6169] text-[14px] font-[500]">
                                    <div className="truncate w-[284px]"
                                         title={record.lessonTitle}>{record.lessonTitle}</div>
                                    <div className="truncate w-[284px]"
                                         title={record.stageName}>{record.stageName}</div>
                                  </td>
                                  <td className="py-2 px-1 border-b border-r border-[#E9E9E9] text-center text-[#5E6169] text-[14px] font-[500]">{formatStudyTime(record.studySeconds || 0)}</td>
                                  <td className="py-2 px-1 border-b border-r border-[#E9E9E9] text-center text-[#5E6169] text-[14px] font-[500]">
                                    {record.grade && (
                                        <div className="flex items-center justify-center">
                                        <img
                                          src={
                                            record.grade === 1 ? grade1 :
                                            record.grade === 10 ? grade2 :
                                            record.grade === 30 ? grade3 :
                                            record.grade === 50 ? grade4 :
                                            record.grade === 100 ? grade5 : grade1
                                          }
                                          className="w-[40px] h-[40px]"
                                          alt={`Grade ${record.grade}`}
                                        />
                                      </div>
                                    )}
                                  </td>
                                  <td className="py-1 px-1 border-b border-[#E9E9E9] text-center text-[#5E6169] text-[14px] font-[700]">
                                    {record.accuracy ? (
                                      <div className="flex flex-col items-center justify-center">
                                        <img
                                          src={
                                            record.accuracy >= 90 ? iconSmile :
                                            record.accuracy >= 70 ? iconSmile2 :
                                            iconSmile3
                                          }
                                          alt="accuracy icon"
                                          className="w-8 h-8"
                                        />
                                        <span
                                          style={{
                                            color: record.accuracy >= 90 ? '#7494FF' :
                                            record.accuracy >= 70 ? '#00B079' : '#EF7070'
                                          }}
                                        >
                                          {record.accuracy.toFixed(0)}%
                                        </span>
                                      </div>
                                    ) : '-'}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div className="absolute bottom-[0] right-[0]">
                      <div className="w-[100px] h-[100px] flex items-center justify-center text-[16px] font-[500] text-[#50555F]">{pageNumber}</div>
                    </div>
                  </div>
                </div>
              );
            });
          })()}

          {/* 자율 학습 결과 상세 페이지 */}
          <div className="mt-[60px] print:mt-0 relative w-full" style={{
            pageBreakAfter: (() => {
              const selfStudyRecords = monthlyData.thisMonthRecords.filter(record => 
                record.sourceType === 'DAILY' || record.sourceType === 'CHALLENGE' || record.sourceType === 'FREE'
              );
              return selfStudyRecords.length <= 10 ? 'unset' : 'always';
            })()
          }}>
            <div className="relative bg-[#ffffff] w-[1040px] h-[1400px] shadow-md print:shadow-none rounded mx-auto">
              {/* 최상단 연.월 표시 */}
              <div className="relative pt-[58px]">
                <div className="w-[940px] h-[58px] bg-[#F6F6F6] relative mx-auto leading-[58px] text-[32px] pl-[20px] font-[700] text-[#9BA5C2] text-left">
                  {year}.{month}
                </div>
              </div>
              <div className="text-[32px] font-bold text-[#061b3b] text-center mt-[33px]">
                자율 학습 결과
              </div>

              {/* 자율 학습 타이틀과 등급 개수 */}
              <div className="mt-[34px] px-[60px]">
                <div className="text-left mb-[20px] relative h-[32px]">
                  <img className="w-[32px] h-[32px] absolute left-[25px]" src={studyIco} alt="자율학습 아이콘" />
                  <div className="text-[24px] font-[700] text-[#50555F] absolute leading-[35px] left-[61px]">
                    자율 학습 등급
                  </div>
                </div>
                
                {/* 등급별 개수 표시 */}
                <div className="text-center mb-[25px]">
                  <div className="relative inline-block">
                    {[1, 10, 30, 50, 100].map((grade, index) => {
                      const count = monthlyData.thisMonthRecords.filter(record => 
                        (record.sourceType === 'DAILY' || record.sourceType === 'CHALLENGE' || record.sourceType === 'FREE') && 
                        record.grade === grade
                      ).length;
                      return (
                        <div key={grade} className="relative inline-block mx-[19px]" style={{top: 0}}>
                          <img 
                            src={
                              grade === 1 ? grade1 :
                              grade === 10 ? grade2 :
                              grade === 30 ? grade3 :
                              grade === 50 ? grade4 :
                              grade5
                            } 
                            alt={`Grade ${grade}`}
                            className="w-[125px] h-[125px] mb-[8px]"
                          />
                          <div className="text-[40px] font-[900] text-[#5E6169] text-center">
                            {count}<span className="text-[20px]">개</span>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>

              {/* 자율 학습 테이블 */}
              <div className="px-[60px]">
                {(() => {
                  const selfStudyRecords = monthlyData.thisMonthRecords.filter(record => 
                    record.sourceType === 'DAILY' || record.sourceType === 'CHALLENGE' || record.sourceType === 'FREE'
                  );
                  
                  if (selfStudyRecords.length === 0) {
                    return (
                      <div className="flex flex-col items-center justify-center p-8 bg-gray-50 rounded-lg">
                        <div className="text-[18px] text-gray-500">이번 달 자율 학습 기록이 없습니다.</div>
                      </div>
                    );
                  }

                  // 첫 번째 페이지는 10개, 추가 페이지는 18개씩
                  const firstPageItems = 10;
                  const displayRecords = selfStudyRecords.slice(0, firstPageItems);
                  
                  return (
                    <div className="overflow-x-auto rounded-t-[20px] overflow-hidden">
                      <table className="min-w-full bg-white border rounded-lg table-fixed">
                        <thead className="bg-[#F3F7FF] text-[18px] font-[700] text-[#9BA5C2] h-[56px] border border-[#F3F7FF]">
                          <tr className="bg-[#F3F7FF] border-b-0">
                            <th className="py-3 text-center font-[700] text-[#9BA5C2] w-[110px]">학습 일시</th>
                            <th className="py-3 text-center font-[700] text-[#9BA5C2] w-[110px]">학습 모드</th>
                            <th className="py-3 text-center font-[700] text-[#9BA5C2] w-[130px]">레벨/단원</th>
                            <th className="py-3 text-center font-[700] text-[#9BA5C2] w-[300px]">스테이지명</th>
                            <th className="py-3 text-center font-[700] text-[#9BA5C2] w-[100px]">학습 시간</th>
                            <th className="py-3 text-center font-[700] text-[#9BA5C2] w-[80px]">등급</th>
                            <th className="py-3 text-center font-[700] text-[#9BA5C2] w-[89px]">정확도</th>
                          </tr>
                        </thead>
                        <tbody>
                          {displayRecords
                            .sort((a, b) => {
                              // 1. 모드 우선순위 정의 (DAILY, CHALLENGE, FREE 순서)
                              const priorityMap = {'DAILY': 1, 'CHALLENGE': 2, 'FREE': 3};
                              const priorityA = priorityMap[a.sourceType] || 99;
                              const priorityB = priorityMap[b.sourceType] || 99;

                              // 2. 우선순위로 정렬
                              if (priorityA !== priorityB) {
                                return priorityA - priorityB;
                              }

                              // 3. 같은 우선순위면 날짜로 정렬
                              return new Date(a.dateTime) - new Date(b.dateTime);
                            })
                            .map((record, index, array) => {
                              // 현재 레코드의 sourceType
                              const currentSourceType = record.sourceType;

                              // 이전 레코드의 sourceType (없으면 null)
                              const prevSourceType = index > 0 ? array[index - 1].sourceType : null;

                              // 새로운 모드 섹션의 시작인지 확인
                              const isNewSection = currentSourceType !== prevSourceType;

                              // 날짜 포맷팅 (시:분만 표시)
                              const formatTime = (dateTimeStr) => {
                                if (!dateTimeStr) return '';

                                const date = new Date(dateTimeStr);
                                const month = String(date.getMonth() + 1).padStart(2, '0');
                                const day = String(date.getDate()).padStart(2, '0');
                                const hours = String(date.getHours()).padStart(2, '0');
                                const minutes = String(date.getMinutes()).padStart(2, '0');

                                return `${month}월${day}일\n${hours}:${minutes}`;
                              };

                              return (
                                <tr
                                  key={index}
                                  className={`h-[72px] ${isNewSection && index > 0 ? 'border-t-2 border-gray-300' : ''}`}
                                >
                                  <td className="py-2 px-1 border-b border-r border-[#E9E9E9] text-center text-[#5E6169] text-[14px] font-[500] whitespace-pre-line">{formatTime(record.dateTime)}</td>
                                  <td className="py-2 px-1 border-b border-r border-[#E9E9E9] text-center text-[#5E6169] text-[14px] font-[500]">
                                    <div className="flex justify-center">
                                      <img
                                        src={
                                          record.sourceType === 'LESSON' ? modeLesson :
                                          record.sourceType === 'HOMEWORK' ? modeHomeWork :
                                          record.sourceType === 'DAILY' ? modeDaily :
                                          record.sourceType === 'FREE' ? modeFree :
                                          record.sourceType === 'CHALLENGE' ? modeChallenge : modeDaily
                                        }
                                        alt={record.sourceType}
                                      />
                                    </div>
                                  </td>
                                  <td className="py-2 px-1 border-b border-r border-[#E9E9E9] text-center text-[#5E6169] text-[14px] font-[500]">
                                    {record.level}레벨 {record.chapterSeq}단원
                                  </td>
                                  <td className="py-2 px-1 border-b border-r border-[#E9E9E9] text-center text-[#5E6169] text-[14px] font-[500]">
                                    <div className="truncate w-[284px]"
                                         title={record.stageName}>{record.stageName}</div>
                                  </td>
                                  <td className="py-2 px-1 border-b border-r border-[#E9E9E9] text-center text-[#5E6169] text-[14px] font-[500]">{formatStudyTime(record.studySeconds || 0)}</td>
                                  <td className="py-2 px-1 border-b border-r border-[#E9E9E9] text-center text-[#5E6169] text-[14px] font-[500]">
                                    {record.grade && (
                                      <div className="flex items-center justify-center">
                                        <img
                                          src={
                                            record.grade === 1 ? grade1 :
                                            record.grade === 10 ? grade2 :
                                            record.grade === 30 ? grade3 :
                                            record.grade === 50 ? grade4 :
                                            record.grade === 100 ? grade5 : grade1
                                          }
                                          className="w-[40px] h-[40px]"
                                          alt={`Grade ${record.grade}`}
                                        />
                                      </div>
                                    )}
                                  </td>
                                  <td className="py-1 px-1 border-b border-[#E9E9E9] text-center text-[#5E6169] text-[14px] font-[700]">
                                    {record.accuracy ? (
                                        <div className="flex flex-col items-center justify-center">
                                          <img
                                              src={
                                                record.accuracy >= 90 ? iconSmile :
                                                    record.accuracy >= 70 ? iconSmile2 :
                                                        iconSmile3
                                              }
                                              alt="accuracy icon"
                                              className="w-8 h-8"
                                          />
                                          <span
                                              style={{
                                                color: record.accuracy >= 90 ? '#7494FF' :
                                                    record.accuracy >= 70 ? '#00B079' : '#EF7070'
                                              }}
                                          >
                                          {record.accuracy.toFixed(0)}%
                                        </span>
                                        </div>
                                    ) : '-'}
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                  );
                })()}
              </div>

              <div className="absolute bottom-[0] right-[0]">
                <div className="w-[100px] h-[100px] flex items-center justify-center text-[16px] font-[500] text-[#50555F]">
                  {(() => {
                    const schoolRecords = monthlyData.thisMonthRecords.filter(record => 
                      record.sourceType === 'HOMEWORK' || record.sourceType === 'LESSON'
                    );
                    const schoolAdditionalPages = Math.max(0, Math.ceil((schoolRecords.length - 10) / 13));
                    return 7 + schoolAdditionalPages; // 학교 학습 추가 페이지 수만큼 증가
                  })()}
                </div>
              </div>
            </div>
          </div>

          {/* 자율 학습 결과 추가 페이지 (20개 초과 시) */}
          {(() => {
            const selfStudyRecords = monthlyData.thisMonthRecords.filter(record => 
              record.sourceType === 'DAILY' || record.sourceType === 'CHALLENGE' || record.sourceType === 'FREE'
            );
            
            if (selfStudyRecords.length <= 10) return null;
            
            const remainingRecords = selfStudyRecords.slice(10);
            const additionalPages = Math.ceil(remainingRecords.length / 13);
            
            // 학교 학습 추가 페이지 수 계산
            const schoolRecords = monthlyData.thisMonthRecords.filter(record => 
              record.sourceType === 'HOMEWORK' || record.sourceType === 'LESSON'
            );
            const schoolAdditionalPages = Math.max(0, Math.ceil((schoolRecords.length - 10) / 13));
            const startPageNumber = 8 + schoolAdditionalPages; // 자율학습 기본 페이지 다음부터
            
            return Array.from({ length: additionalPages }, (_, pageIndex) => {
              const startIndex = pageIndex * 13;
              const endIndex = Math.min(startIndex + 13, remainingRecords.length);
              const pageRecords = remainingRecords.slice(startIndex, endIndex);
              const pageNumber = startPageNumber + pageIndex;
              const isLastPage = pageIndex === additionalPages - 1;
              
              return (
                <div key={`self-page-${pageIndex}`} className="mt-[60px] print:mt-0 relative w-full" style={isLastPage ? {} : { pageBreakAfter: 'always' }}>
                  <div className="relative bg-[#ffffff] shadow-md print:shadow-none rounded w-[1040px] h-[1400px]">
                    {/* 최상단 연.월 표시 */}
                    <div className="relative pt-[58px]">
                      <div className="w-[940px] h-[58px] bg-[#F6F6F6] relative mx-auto leading-[58px] text-[32px] pl-[20px] font-[700] text-[#9BA5C2] text-left">
                        {year}.{month}
                      </div>
                    </div>
                    <div className="text-[32px] font-bold text-[#50555F] text-center mt-[33px]">
                      자율 학습 결과 {pageIndex + 2}
                    </div>

                    <div className="mt-[50px] px-[60px]">
                      <div className="overflow-x-auto rounded-t-[20px] overflow-hidden">
                        <table className="min-w-full bg-white border rounded-lg table-fixed">
                          <thead className="bg-[#F3F7FF] text-[18px] font-[700] text-[#9BA5C2] h-[56px] border border-[#F3F7FF]">
                            <tr className="bg-[#F3F7FF] border-b-0">
                              <th className="py-3 text-center font-[700] text-[#9BA5C2] w-[110px]">학습 일시</th>
                              <th className="py-3 text-center font-[700] text-[#9BA5C2] w-[110px]">학습 모드</th>
                              <th className="py-3 text-center font-[700] text-[#9BA5C2] w-[130px]">레벨/단원</th>
                              <th className="py-3 text-center font-[700] text-[#9BA5C2] w-[300px]">스테이지명</th>
                              <th className="py-3 text-center font-[700] text-[#9BA5C2] w-[100px]">학습 시간</th>
                              <th className="py-3 text-center font-[700] text-[#9BA5C2] w-[80px]">등급</th>
                              <th className="py-3 text-center font-[700] text-[#9BA5C2] w-[89px]">정확도</th>
                            </tr>
                          </thead>
                          <tbody>
                            {pageRecords
                              .sort((a, b) => {
                                // 1. 모드 우선순위 정의 (DAILY, CHALLENGE, FREE 순서)
                                const priorityMap = {'DAILY': 1, 'CHALLENGE': 2, 'FREE': 3};
                                const priorityA = priorityMap[a.sourceType] || 99;
                                const priorityB = priorityMap[b.sourceType] || 99;

                                // 2. 우선순위로 정렬
                                if (priorityA !== priorityB) {
                                  return priorityA - priorityB;
                                }

                                // 3. 같은 우선순위면 날짜로 정렬
                                return new Date(a.dateTime) - new Date(b.dateTime);
                              })
                              .map((record, index, array) => {
                                // 현재 레코드의 sourceType
                                const currentSourceType = record.sourceType;

                                // 이전 레코드의 sourceType (없으면 null)
                                const prevSourceType = index > 0 ? array[index - 1].sourceType : null;

                                // 새로운 모드 섹션의 시작인지 확인
                                const isNewSection = currentSourceType !== prevSourceType;

                                // 날짜 포맷팅 함수
                                const formatTime = (dateTimeStr) => {
                                  if (!dateTimeStr) return '';
                                  const date = new Date(dateTimeStr);
                                  const month = String(date.getMonth() + 1).padStart(2, '0');
                                  const day = String(date.getDate()).padStart(2, '0');
                                  const hours = String(date.getHours()).padStart(2, '0');
                                  const minutes = String(date.getMinutes()).padStart(2, '0');
                                  return `${month}월${day}일\n${hours}:${minutes}`;
                                };
                              
                                return (
                                  <tr
                                    key={index}
                                    className={`h-[72px] ${isNewSection && index > 0 ? 'border-t-2 border-gray-300' : ''}`}
                                  >
                                    <td className="py-2 px-1 border-b border-r border-[#E9E9E9] text-center text-[#5E6169] text-[14px] font-[500] whitespace-pre-line">{formatTime(record.dateTime)}</td>
                                    <td className="py-2 px-1 border-b border-r border-[#E9E9E9] text-center text-[#5E6169] text-[14px] font-[500]">
                                      <div className="flex justify-center">
                                        <img
                                          src={
                                            record.sourceType === 'LESSON' ? modeLesson :
                                            record.sourceType === 'HOMEWORK' ? modeHomeWork :
                                            record.sourceType === 'DAILY' ? modeDaily :
                                            record.sourceType === 'FREE' ? modeFree :
                                            record.sourceType === 'CHALLENGE' ? modeChallenge : modeDaily
                                          }
                                          alt={record.sourceType}
                                        />
                                      </div>
                                    </td>
                                    <td className="py-2 px-1 border-b border-r border-[#E9E9E9] text-center text-[#5E6169] text-[14px] font-[500]">
                                      {record.level}레벨 {record.chapterSeq}단원
                                    </td>
                                    <td className="py-2 px-1 border-b border-r border-[#E9E9E9] text-center text-[#5E6169] text-[14px] font-[500]">
                                      <div className="truncate w-[284px]" title={record.stageName}>{record.stageName}</div>
                                    </td>
                                    <td className="py-2 px-1 border-b border-r border-[#E9E9E9] text-center text-[#5E6169] text-[14px] font-[500]">{formatStudyTime(record.studySeconds || 0)}</td>
                                    <td className="py-2 px-1 border-b border-r border-[#E9E9E9] text-center text-[#5E6169] text-[14px] font-[500]">
                                      {record.grade && (
                                        <div className="flex items-center justify-center">
                                          <img
                                            src={
                                              record.grade === 1 ? grade1 :
                                              record.grade === 10 ? grade2 :
                                              record.grade === 30 ? grade3 :
                                              record.grade === 50 ? grade4 :
                                              record.grade === 100 ? grade5 : grade1
                                            }
                                            className="w-[40px] h-[40px]"
                                            alt={`Grade ${record.grade}`}
                                          />
                                        </div>
                                      )}
                                    </td>
                                    <td className="py-1 px-1 border-b border-[#E9E9E9] text-center text-[#5E6169] text-[14px] font-[700]">
                                      {record.accuracy ? (
                                        <div className="flex flex-col items-center justify-center">
                                          <img
                                            src={
                                              record.accuracy >= 90 ? iconSmile :
                                              record.accuracy >= 70 ? iconSmile2 :
                                              iconSmile3
                                            }
                                            alt="accuracy icon"
                                            className="w-8 h-8"
                                          />
                                          <span
                                            style={{
                                              color: record.accuracy >= 90 ? '#7494FF' :
                                              record.accuracy >= 70 ? '#00B079' : '#EF7070'
                                            }}
                                          >
                                            {record.accuracy.toFixed(0)}%
                                          </span>
                                        </div>
                                      ) : '-'}
                                    </td>
                                  </tr>
                                );
                              })}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div className="absolute bottom-[0] right-[0]">
                      <div className="w-[100px] h-[100px] text-center leading-[100px] text-[16px] font-[500] text-[#50555F]">{pageNumber}</div>
                    </div>
                  </div>
                </div>
              );
            });
          })()}

       </div>
     </div>
   );
 };

export default StudentMonthlyReport; 